import React, { useState, useEffect, Fragment } from "react";
import { DataGrid } from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Input from "@mui/material/Input";
import { Stack, Alert, Collapse, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Tooltip, ButtonGroup } from '@mui/material';

import { Controller } from "react-hook-form";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import OutlinedInput from '@mui/material/OutlinedInput';
// import ListItemText from '@mui/material/ListItemText';
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import useGridColumnSetup, { saveApp, useValidationSchema, useMenuItemProps, useHandleMultiSelectChange, handleBooleanRadioButtonChange, handleSecurityBreachChange } from '../hooks/useAppsLogic'
// import Chip from "@mui/material/Chip";
// import CancelIcon from "@mui/icons-material/Cancel";
import _without from "lodash/without";
import Switch from '@mui/material/Switch';
import SelfSizingTextField from "./Widgets/selfSizingTextField";
import MultiSelectWithChips from "./Widgets/MultiSelectWithChips";
import LoadingOverlay from "react-loading-overlay";
import DarkBackground from "./Widgets/TransparentLoadingDisplay";
import "../styles.css";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import { GetAccessToken } from "../components/Dashboard/Utilities";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Popper from '@mui/material/Popper';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import MenuList from '@mui/material/MenuList';
import ClickAwayListener from '@mui/material/ClickAwayListener';

import { GppGood } from "@mui/icons-material";
import { GppBad } from "@mui/icons-material";
import { GppMaybe } from "@mui/icons-material";
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import MuiToggleButton from '@mui/material/ToggleButton';
import InputAdornment from '@mui/material/InputAdornment';
import PIAFormContent from "./PIAFormContent";

//import CustomToolbar from "./Widgets/CustomToolbar";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  //GridToolbarDensitySelector,
  useGridApiContext,
  useGridApiRef,
  //   GridCsvExportOptions,
  //   GridCsvGetRowsToExportParams,
  gridVisibleSortedRowIdsSelector
} from '@mui/x-data-grid';
import { styled } from "@mui/material/styles";
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import { useParams } from "react-router";
import Link from '@mui/material/Link';
import { set } from "date-fns";
import HelpCenterOutlinedIcon from '@mui/icons-material/HelpCenterOutlined';

// debugger;
var reRender = 1;

const useLogicAsync = (accessToken, setIsLoading) => {
  const [errorA, setErrorA] = useState(null);
  const [loading, setLoading] = useState(true);
  const [applications, setApplications] = useState(null);

  const { userEmail } = localStorage.getItem("userEmail");


  useEffect(() => {
    async function getA(accessToken) {
      try {
        setErrorA(null);
        const requestOptions = {
          // method: method,
          headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
          //body: JSON.stringify(user)
        };
        if (accessToken === false) {
          return;
        }

        const response = await fetch('pia?userInfo=' + localStorage.getItem("userEmail"), requestOptions);
        const data = await response.json();

        setApplications(data);
        setIsLoading(false);
        //setLoading(false);
      } catch (e) {
        setIsLoading(false);
        //setLoading(false);
        setErrorA(e);
      } finally {
        //setLoading(false);
        //debugger;
      }
    };
    getA(accessToken);
  }, [reRender]);

  return [applications, errorA, loading];
}

const FetchApplications = (accessToken, setIsLoading) => {

  const [value, error, loading] = useLogicAsync(accessToken, setIsLoading);
  return [value, error, loading];
}

const ToggleButton = styled(MuiToggleButton)(({ selectedColor }) => ({
  '&.Mui-selected, &.Mui-selected:hover': {
    color: 'white',
    backgroundColor: selectedColor,
  },
}));

LoadingOverlay.propTypes = undefined
const DarkBackgroundDiv = DarkBackground

export default function DataTable() {
  var id = useParams().id;

  //open edit dialog if id is passed in
  const [open, setOpen] = React.useState(false);
  const [initialEditId, setInitialEditId] = React.useState(0);
  const [editDialogPopulated, setEditDialogPopulated] = React.useState(false);


  if (initialEditId == 0 && id && !open) {
    setInitialEditId(id);
    //console.log("id: " + id);
    setOpen(true);
  }

  const handleCommonSenseChange = (event, newValue) => {

    setCommonSense(newValue);
  };
  const apiRef = useGridApiRef();

  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [deleteName, setDeleteName] = React.useState('');
  const [deleteId, setDeleteId] = React.useState('');
  const [successOpen, setSuccessOpen] = React.useState(false);
  const [errorOpen, setErrorOpen] = React.useState(false);
  const [successDialogOpen, setSuccessDialogOpen] = React.useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState(false);
  const [editOrAddTitle, setEditOrAddTitle] = React.useState('');
  const [startDate, setStartDate] = React.useState(new Date());
  const [approvalDate, setApprovalDate] = React.useState(new Date());
  const [endDate, setEndDate] = React.useState('');
  const [gradesSelected, setgradesSelected] = useState([]);
  const [processingPurposeSelected, setProcessingPurposeSelected] = useState([]);
  const [legalBasisForProcessingInfoSelected, setLegalBasisForProcessingInfoSelected] = useState([]);
  const [specialCategoryDataSelected, setSpecialCategoryDataSelected] = useState([]);
  const [studentInfoSelected, setstudentInfoSelected] = useState([]);
  const [staffInfoSelected, setstaffInfoSelected] = useState([]);
  const [parentInfoSelected, setparentInfoSelected] = useState([]);
  const [alumniInfoSelected, setalumniInfoSelected] = useState([]);
  const [volunteerInfoSelected, setVolunteerInfoSelected] = useState([]);
  const [areaOfUseSelected, setareaOfUseSelected] = useState([]);
  const [collectionModesSelected, setCollectionModesSelected] = useState([]);
  const [generalOpen, setGeneralOpen] = useState(true);
  const [dataCollectionOpen, setDataCollectionOpen] = useState(false);
  const [dataProtectionOpen, setDataProtectionOpen] = useState(false);
  const [dataHandlingOpen, setDataHandlingOpen] = useState(false);
  const [otherOpen, setOtherOpen] = useState(false);
  const [genAIOpen, setGenAIOpen] = useState(false);
  const [approvalOpen, setApprovalOpen] = useState(false);
  const [recordsOfProcessingOpen, setRecordsOfProcessingOpen] = useState(false);
  const [subcontractorDataProtection, setSubcontractorDataProtection] = useState('0');
  const [commonSense, setCommonSense] = useState('0');
  const [securityBreachInt, setSecurityBreachInt] = useState(false);
  const [cloudHosted, setCloudHosted] = useState(false);
  const [otherAuditShow, setotherAuditShow] = useState(false);
  const [otherDepartmentsShow, setotherDepartmentsShow] = useState(false);
  const [otherProcessingPurposeShow, setOtherProcessingPurposeShow] = useState(false);
  const [lastAuditDate, setLastAuditDate] = React.useState('');
  const [dataSinglePurpose, setDataSinglePurpose] = React.useState(false);
  const [dataLocationSelected, setdataLocationSelected] = useState([]);
  const [transferSafeguardsSelected, setTransferSafeguardsSelected] = useState([]);
  const [securityMeasuresSelected, setSecurityMeasuresSelected] = useState([]);
  const [gDPRCompliant, setgDPRCompliant] = useState(false);
  const [hasExternalLLMs, setHasExternalLLMs] = useState(false);
  const [automatedDecisionMaking, setAutomatedDecisionMaking] = useState(false);
  const [llmroviders, setllmProviders] = useState('');
  const [llmTraining, setllmTraining] = useState('');
  const [llmDataShared, setllmDataShared] = useState(false);
  const [vendorSpecialCategoryData, setVendorSpecialCategoryData] = useState(false);
  const [llmUnder18Treatment, setllmUnder18Treatment] = useState('');
  const [llmRestrict, setllmRestrict] = useState('');
  const [internetPIPublished, setinternetPIPublished] = useState(false);
  const [dataBreachCompliant, setdataBreachCompliant] = useState(false);
  const [approved, setapproved] = useState(false);
  const [notApproved, setnotApproved] = useState(false);
  const [gradesNASelected, setgradesNASelected] = useState(false);
  const [studentInfoNASelected, setstudentInfoNASelected] = useState(false);
  const [staffInfoNASelected, setstaffInfoNASelected] = useState(false);
  const [parentInfoNASelected, setparentInfoNASelected] = useState(false);
  const [alumniInfoNASelected, setalumniInfoNASelected] = useState(false);
  const [volunteerInfoNASelected, setVolunteerInfoNASelected] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isAdding, setIsAdding] = useState(false);
  const [lastUpdatedDate, setLastUpdatedDate] = useState(new Date());
  const [completedBy, setCompletedBy] = useState('');
  const [isSchoolRecord, setIsSchoolRecord] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [tenantPiaId, setTenantPiaId] = useState(0);
  const [cloudProviderOtherValue, setCloudProviderOtherValue] = useState('');
  const [cloudProviderOtherShow, setCloudProviderOtherShow] = useState(false);
  const [bgOpen, setBgOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(2);
  const [vendorConfirmed, setVendorConfirmed] = React.useState(false);
  const [coppa, setCoppa] = React.useState('0');
  const [gDPRComplianceLevel, setGDPRComplianceLevel] = React.useState('0');
  const [policyLastUpdated, setPolicyLastUpdated] = React.useState('');
  const [applicationDataRows, setApplicationDataRows] = useState([]);
  const [internationalTransferFlag, setInternationalTransferFlag] = useState(true);
  const [hasROPModule, setHasROPModule] = useState(false);
  const handleVendorConfirmedChange = () => {

    setVendorConfirmed(!vendorConfirmed);
  };

  const handleCoppaChange = (event, newValue) => {

    setCoppa(newValue);
  };

  const handleGDPRChange = (event, newValue) => {

    setGDPRComplianceLevel(newValue);
  };

  const showSuccess = message => {
    setSuccessOpen(true);
    setSuccessMessage(message);
    setAccessToken(false);
    setTimeout(() => {
      setSuccessOpen(false);
    }, 3000);
  };

  const showSuccessInDialog = message => {
    setSuccessDialogOpen(true);
    setSuccessMessage(message);
    setAccessToken(false);
    setTimeout(() => setSuccessDialogOpen(false), 3000);
  };

  const showError = () => {
    setErrorOpen(true);
    setTimeout(() => setErrorOpen(false), 3000);
  };

  const showErrorInDialog = () => {
    setErrorDialogOpen(true);
    setTimeout(() => setErrorDialogOpen(false), 3000);
  };

  //validation schema setup
  var validationSchema = useValidationSchema();

  const runValidations = () => {

    validationSchema
      .validate(returnData[0].applications[2], { abortEarly: false })
      .then((responseData) => {
        console.log("no validation errors");
        console.log(responseData);
        console.log(errors);
        //setCurrentErrors([]);
      })
      .catch((err) => {
        console.log(err);
        console.log(err.name); // ValidationError
        console.log(err.errors);
        //setCurrentErrors(err.errors);
      });
  };

  const {
    register,
    control,
    setValue,
    getValues,
    handleSubmit,
    clearErrors,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
  });

  const handleClickOpen = (event, cellValues) => {

    setIsAdding(false);
    var dataRow = cellValues.row;
    //debugger;
    var cloudProviderList = returnData[0].cloudProviderList;
    //find 'Other' in cloud provider list
    var otherCloudProvider = cloudProviderList.find(x => x.name === 'Other');
    //set the value of the 'Other' option
    if (otherCloudProvider) {
      setCloudProviderOtherValue(otherCloudProvider.lookupItemId);

      setCloudProviderOtherShow(dataRow.cloudProviderId === otherCloudProvider.lookupItemId);
    }
    setValue("id", dataRow.id);
    setValue("name", dataRow.name);
    setValue("vendorId", dataRow.vendorId);
    setValue("url", dataRow.url);
    setValue("description", dataRow.description);

    setValue("cloudProviderId", dataRow.cloudProviderId ?? '');
    setValue("legalBasisForProcessingId", dataRow.legalBasisForProcessingId ?? '');
    setValue("cloudProvider", dataRow.cloudProvider ?? '');

    setPolicyLastUpdated("");
    setValue("cloudHosted", dataRow.cloudHosted ?? false);
    setValue("itOwnerId", dataRow.itOwnerId);
    setValue("collectionModeId", dataRow.collectionModeId);
    setValue("collectionModeOther", dataRow.collectionModeOther);
    setValue("startDate", dataRow.startDate);
    setValue("endDate", dataRow.endDate);
    setValue("other", dataRow.other);
    // setValue("privacyUrl", dataRow.privacyUrl);
    setValue("privacyNotification", dataRow.privacyNotification);
    setValue("privacyTraining", dataRow.privacyTraining);
    setValue("generalApplicationNotes", dataRow.generalApplicationNotes);
    setValue("dataCollectionNotes", dataRow.dataCollectionNotes);
    setValue("dataProtectionNotes", dataRow.dataProtectionNotes);
    setValue("dataHandlingNotes", dataRow.dataHandlingNotes);
    setValue("complianceNotes", dataRow.complianceNotes);
    setValue("approvalNotes", dataRow.approvalNotes);
    setValue("subcontractors", dataRow.subcontractors);
    setCloudHosted(dataRow.cloudHosted ?? false);
    setSubcontractorDataProtection(dataRow.subcontractorDataProtection);
    setSecurityBreachInt(dataRow.securityBreachInt);
    setValue("securityBreachDescription", dataRow.securityBreachDescription);
    setDataSinglePurpose(dataRow.dataSinglePurpose);
    setStartDate(dataRow.startDate);
    setApprovalDate(dataRow.approvalDate);
    setEndDate(dataRow.endDate);
    setLastAuditDate(dataRow.lastAuditDate);
    setValue("lastAuditDate", dataRow.lastAuditDate);
    setValue("securityBreachPlan", dataRow.securityBreachPlan);
    setValue("privacyPracticeReview", dataRow.privacyPracticeReview);
    setValue("vendorSaleAssurance", dataRow.vendorSaleAssurance);
    setValue("dataBackup", dataRow.dataBackup);
    setValue("lossProtection", dataRow.lossProtection);
    setValue("dataSinglePurpose", dataRow.dataSinglePurpose);
    setValue("dataRetentionPolicy", dataRow.dataRetentionPolicy);
    setValue("dataRetentionPolicyr", dataRow.dataRetentionPolicy);
    setValue("recordsOfProcessingNotes", dataRow.recordsOfProcessingNotes);
    setValue("dataRetentionLength", dataRow.dataRetentionLength);
    setValue("dataAfterDiscontinuing", dataRow.dataAfterDiscontinuing);
    setValue("dataAfterDiscontinuingr", dataRow.dataAfterDiscontinuing);
    setValue("gDPRCompliant", dataRow.gDPRCompliant ?? false);
    setgDPRCompliant(dataRow.gDPRCompliant ?? false);
    setinternetPIPublished(dataRow.internetPIPublished ?? false);
    setdataBreachCompliant(dataRow.dataBreachCompliant ?? false)
    setapproved(dataRow.approved ?? false)
    setValue("approverId", dataRow.approverId ?? '');
    setValue("legalBasisForProcessingId", dataRow.legalBasisForProcessingId ?? '');
    setValue("processingPurposeDescription", dataRow.processingPurposeDescription ?? '');
    setValue("processingPurposeDescriptionr", dataRow.processingPurposeDescription ?? '');
    setnotApproved(dataRow.notApproved ?? false)
    setValue("notApprovedReason", dataRow.notApprovedReason);
    setValue("applicableDepartmentsOther", dataRow.applicableDepartmentsOther);
    setLastUpdatedDate(dataRow.lastUpdatedDate);
    setCompletedBy(dataRow.completedBy);
    setTenantPiaId(dataRow.tenantPiaId);

    if (dataRow.policyLastUpdated === '') {
      setPolicyLastUpdated(null);
    }
    else {
      setPolicyLastUpdated(dataRow.policyLastUpdated);
    }


    setVendorConfirmed(dataRow.vendorConfirmed);
    setCoppa(dataRow.coppa);
    setGDPRComplianceLevel(dataRow.gDPRCompliance);
    setCommonSense(dataRow.commonSense);

    setValue("commonSenseRating", dataRow.commonSenseScore);
    setValue("evalUrl", dataRow.evalUrl);
    setValue("contractUrl", dataRow.contractUrl);
    setValue("dataLocationOther", dataRow.dataLocationOther);
    setValue("hasExternalLLMs", dataRow.hasExternalLLMs);
    setValue("automatedDecisionMaking", dataRow.automatedDecisionMaking);
    setHasExternalLLMs(dataRow.hasExternalLLMs);
    setAutomatedDecisionMaking(dataRow.automatedDecisionMaking);
    setValue("llmProviders", dataRow.llmProviders);
    setValue("llmTraining", dataRow.llmTraining);
    setllmTraining(dataRow.llmTraining);
    setValue("llmDataShared", dataRow.llmDataShared);
    setllmDataShared(dataRow.llmDataShared);
    setValue("llmUnder18Treatment", dataRow.llmUnder18Treatment);
    setValue("llmRestrict", dataRow.llmRestrict);

    setValue("transferSafeguardsNotes", dataRow.transferSafeguardsNotes);
    if (dataRow.auditFrequencyId === null) {
      setValue("auditFrequencyId", 0);
    }
    else {
      setValue("auditFrequencyId", dataRow.auditFrequencyId);
    }
    setValue("auditFrequencyOther", dataRow.auditFrequencyOther);

    //show other box for departments (areasfuse)

    function checkOther(value) {
      return (value === 'Other');
    }


    if (dataRow.areaOfUseSelected !== null) {
      setotherDepartmentsShow(dataRow.areaOfUseSelected.find(checkOther));
    }
    else {
      setotherDepartmentsShow(false);
    }

    if (dataRow.auditFrequencyId === -1) {
      setotherAuditShow(true);
    }
    else {
      setotherAuditShow(false);
    }
    //these can't be null
    if (dataRow.gradesSelected === null) {
      setgradesSelected([]);
    } else {
      setgradesSelected(dataRow.gradesSelected);
    }
    // debugger;
    if (dataRow.processingPurposeSelected === null) {
      setProcessingPurposeSelected([]);
    } else {
      setProcessingPurposeSelected(dataRow.processingPurposeSelected);
    }

    if (dataRow.studentInfoSelected === null) {
      setstudentInfoSelected([]);
    } else {
      setstudentInfoSelected(dataRow.studentInfoSelected);
    }

    if (dataRow.staffInfoSelected === null) {
      setstaffInfoSelected([]);
    } else {
      setstaffInfoSelected(dataRow.staffInfoSelected);
    }
    if (dataRow.parentInfoSelected === null) {
      setparentInfoSelected([]);
    } else {
      setparentInfoSelected(dataRow.parentInfoSelected);
    }

    if (dataRow.alumniInfoSelected === null) {
      setalumniInfoSelected([]);
    } else {
      setalumniInfoSelected(dataRow.alumniInfoSelected);
    }

    if (dataRow.volunteerInfoSelected === null) {
      setVolunteerInfoSelected([]);
    } else {
      setVolunteerInfoSelected(dataRow.volunteerInfoSelected);
    }

    if (dataRow.areaOfUseSelected === null) {
      setareaOfUseSelected([]);
    } else {
      setareaOfUseSelected(dataRow.areaOfUseSelected);
    }
    if (dataRow.dataLocationSelected === null) {
      setdataLocationSelected([]);
    } else {
      setdataLocationSelected(dataRow.dataLocationSelected);
    }

    if (dataRow.processingPurposeSelected === null) {
      setProcessingPurposeSelected([]);
    } else {
      setProcessingPurposeSelected(dataRow.processingPurposeSelected);
    }

    if (dataRow.specialCategoryDataSelected === null) {
      setSpecialCategoryDataSelected([]);
    } else {
      setSpecialCategoryDataSelected(dataRow.specialCategoryDataSelected);
    }
    //if specialCategoryDataSelected has values, set vendorSpecialCategoryData to true
    if (dataRow.specialCategoryDataSelected !== null && dataRow.specialCategoryDataSelected.length > 0) {
      setVendorSpecialCategoryData(true);
    } else {
      setVendorSpecialCategoryData(false);
    }


    if (dataRow.transferSafeguardsSelected === null) {
      setTransferSafeguardsSelected([]);
    } else {
      setTransferSafeguardsSelected(dataRow.transferSafeguardsSelected);
    }

    if (dataRow.securityMeasuresSelected === null) {
      setSecurityMeasuresSelected([]);
    } else {
      setSecurityMeasuresSelected(dataRow.securityMeasuresSelected);
    }

    //update international transfer flag
    const euCountries = returnData[0].euCountryList;
    const selectedValues = dataRow.dataLocationSelected;
    if (selectedValues !== null) {
      for (var j = 0; j < selectedValues.length; j++) {
        if (euCountries.indexOf(selectedValues[j]) > -1) {
          setInternationalTransferFlag(false);
          break;
        }
      }
    }


    if (dataRow.collectionModesSelected === null) {
      setCollectionModesSelected([]);
    } else {
      setCollectionModesSelected(dataRow.collectionModesSelected);
    }

    setEditOrAddTitle('Edit');


    clearErrors();
    setOpen(true);


    if (dataRow.isSchoolRecord === false && !currentUser.isSuperAdmin) {
      setEditOrAddTitle('View');

    }
    setIsSchoolRecord(dataRow.isSchoolRecord);
  };

  const handleDeleteOpen = (event, cellValues) => {
    var dataRow = cellValues.row;
    setDeleteName(dataRow.name);

    //if tenantPiaId exists, it is a tenant record, otherwise it is a master record
    if (dataRow.tenantPiaId !== null && dataRow.tenantPiaId !== 0) {
      setDeleteId(dataRow.tenantPiaId);
    }
    else {
      setDeleteId(dataRow.id);
    }

    setDeleteOpen(true);
  };

  //grid setup
  var columns;

  const [accessToken, setAccessToken] = useState(localStorage.getItem("userToken"));

  //var accessToken; 

  GetAccessToken(setAccessToken, accessToken).then(result => {

  }).catch(err => {

  });

  var returnData = FetchApplications(accessToken, setIsLoading);
  // debugger;
  if (returnData[0] !== null && applicationDataRows.length === 0) {
    setApplicationDataRows(returnData[0].applications);
    setHasROPModule(returnData[0].hasROPModule);
  }
  // console.log(returnData);

  var applicationData = [];
  var vendorsToDisplay = [];
  var itOwners = [];
  var collectionModes = [];
  var grades = [];
  var processingPurposes = [];
  var legalBasisForProcessingInfoItems = [];
  var specialCategoryDataItems = [];
  var studentItems = [];
  var staffItems = [];
  var parentItems = [];
  var alumniItems = [];
  var volunteerItems = [];
  var areaOfUseItems = [];
  var auditFrequencyList = [];
  var dataLocationItems = [];
  var transferSafeguardsItems = [];
  var securityMeasuresItems = [];
  var processingPurposeItems = [];
  var cloudProviderItems = [];
  var collectionModeItems = [];
  var approverList = [];
  var currentUser = { isSuperAdmin: false };

  const filterItems = [[{ columnField: 'isSchoolRecord', operatorValue: 'is', value: 'true' }], [{ columnField: 'isSchoolRecord', operatorValue: 'is', value: 'false' }], []];
  const [filterItem, setFilterItem] = useState(filterItems[2]);

  var initialGridState;
  initialGridState = {
    pagination: {
      pageSize: 1000,

    },
    ...applicationData.initialState,
    filter: {
      ...applicationData.initialState?.filter,
      filterModel: {
        items: [
          filterItem,
        ],
      },
    },
  };
  const populateEditDialogData = (dataRow) => {

    handleClickOpen(null, dataRow);

  };

  if (returnData) {
    // var loading = returnData[2];
    //var loading = false;
    var error = returnData[1];

    if (initialEditId != 0 && returnData[0] != null && returnData[0].applications !== null) {
      //find data with tenantPiaId = id

      var dataRow = returnData[0].applications.find(x => x.tenantPiaId == parseInt(initialEditId));
      if (dataRow != null && !editDialogPopulated) {
        populateEditDialogData({ row: dataRow });
        setEditDialogPopulated(true);
      }
    }
  }

  const [filterButtonEl, setFilterButtonEl] = React.useState(null);
  const CustomToolbar = React.useCallback(() => {
    //const apiRef = useGridApiContext();

    const getNoRowsToExport = ({ apiRef }) => {

      // Get all row IDs currently in the grid
      // console.log(apiRef.current.state.rows);
      const allRowIds = Array.from(apiRef.current.state.rows.ids);
      const filteredRowIds = allRowIds.filter(id => {
        const row = apiRef.current.getRow(id);
        return row.isSchoolRecord === true;
      });

      return filteredRowIds;
      return [];
    };
    const getFilteredRows = ({ apiRef }) =>
      gridVisibleSortedRowIdsSelector(apiRef);


    // const handleExport = (options) =>
    //   apiRef.current.exportDataAsCsv(options);

    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        {/* <GridToolbarFilterButton ref={setFilterButtonEl} /> */}
        {/* <GridToolbarDensitySelector />  */}
        <GridToolbarExport
          csvOptions={{ allColumns: true, fileName: 'DataExport', getRowsToExport: getNoRowsToExport }}
          printOptions={{ disableToolbarButton: true }}
        />
        {/* <Button
          // {...buttonBaseProps}
          onClick={() => handleExport({ getRowsToExport: getFilteredRows })}
        >
          Filtered rows
        </Button> */}
      </GridToolbarContainer>
    );
  }, []);



  // useEffect(() => {
  //   if (returnData && returnData[0] !== null) {
  //     if (!isSaving) {
  //       //debugger;
  //       setIsLoading(false);
  //     }
  //   }
  //   else {
  //     setIsLoading(true);
  //   }
  // }, [returnData])


  if (returnData && returnData[0] !== null) {

    //loading = false;

    applicationData = returnData[0].applications;
    //setApplicationData(returnData[0].applications);

    currentUser = returnData[0].currentUser;

    // if (returnData[0].gridState.length > 0) {


    //   initialGridState = JSON.parse(returnData[0].gridState);
    // }



    //console.log(returnData[0]);

    vendorsToDisplay = returnData[0].vendorNames;
    itOwners = returnData[0].itOwnerNames;
    //collectionModes = returnData[0].collectionModeNames;

    grades = returnData[0].gradeList;
    processingPurposes = returnData[0].processingPurposeList;
    legalBasisForProcessingInfoItems = returnData[0].legalBasisForProcessingList;
    studentItems = returnData[0].studentInfoList;
    staffItems = returnData[0].staffInfoList;
    parentItems = returnData[0].parentInfoList;
    alumniItems = returnData[0].alumniInfoList;
    volunteerItems = returnData[0].volunteerInfoList;
    areaOfUseItems = returnData[0].areaOfUseList;
    auditFrequencyList = returnData[0].auditFrequencyList;
    dataLocationItems = returnData[0].dataLocationList;
    transferSafeguardsItems = returnData[0].transferSafeguardsList;
    securityMeasuresItems = returnData[0].securityMeasuresList;
    processingPurposeItems = returnData[0].processingPurposeList;
    specialCategoryDataItems = returnData[0].specialCategoryDataList;
    cloudProviderItems = returnData[0].cloudProviderList;
    collectionModeItems = returnData[0].collectionModeList;
    approverList = returnData[0].approverList;

  }

  columns = useGridColumnSetup(handleClickOpen, handleDeleteOpen, showSuccess, showError, currentUser.isSuperAdmin);

  const addApplication = (event, cellValues) => {
    setIsAdding(true);
    setValue("id", -1);
    setValue("name", '');
    setValue("vendorId", 0);
    setValue("itOwnerId", 0);
    setValue("collectionModeId", 0);
    setValue("collectionModeOther", '');
    setValue("url", '');
    setValue("description", '');
    setValue("cloudHosted", '');
    setCloudHosted(null);
    setValue("cloudProviderId", '');
    setValue("legalBasisForProcessingId", '');
    setValue("cloudProvider", '');
    setValue("startDate", '');
    setValue("endDate", '');
    setValue("other", '');
    setStartDate(null);
    setApprovalDate(null);
    setEndDate(null);
    setValue("gradesSelected", "");
    setgradesSelected([]);
    setstudentInfoSelected([]);
    setstaffInfoSelected([]);
    setparentInfoSelected([]);
    setalumniInfoSelected([]);
    setVolunteerInfoSelected([]);
    setCollectionModesSelected([]);
    setareaOfUseSelected([]);
    // setValue("privacyUrl", "");
    setValue("privacyNotification", "");
    setPolicyLastUpdated(null);
    setValue("privacyTraining", "");
    setValue("subcontractors", "");
    setSubcontractorDataProtection(null);
    setSecurityBreachInt(null);
    setDataSinglePurpose(null);
    setValue("securityBreachDescription", '');
    setValue("subcontractorDataProtection", null);
    setValue("auditFrequencyId", 0);
    setValue("auditFrequencyOther", '');
    setValue("lastAuditDate", '');
    setLastAuditDate(null);
    setValue("securityBreachPlan", '');
    setValue("privacyPracticeReview", '');
    setValue("vendorSaleAssurance", '');
    setValue("generalApplicationNotes", '');
    setValue("dataCollectionNotes", '');
    setValue("dataProtectionNotes", '');
    setValue("dataHandlingNotes", '');
    setValue("complianceNotes", '');
    setValue("dataBackup", '');
    setValue("lossProtection", '');
    setValue("dataSinglePurpose", false);
    setValue("dataRetentionPolicy", '');
    setValue("dataRetentionPolicyr", '');
    setValue("recordsOfProcessingNotes", '');
    setValue("dataRetentionLength", '');
    setValue("dataAfterDiscontinuing", '');
    setValue("dataAfterDiscontinuingr", '');
    setValue("gDPRCompliant", false);
    setgDPRCompliant(false);
    setinternetPIPublished(false);
    setdataBreachCompliant(false);
    setapproved(false);
    setnotApproved(false);
    setValue("notApprovedReason", '');
    setValue("approverId", '');
    setValue("approvalNotes", '');
    setValue("applicableDepartmentsOther", '');
    setValue("evalUrl", '');
    setValue("dataLocationOther", '');
    setValue("commonSenseScore", 0);
    setCloudProviderOtherShow(false);
    setotherDepartmentsShow(false);
    setCommonSense('0');
    setValue("commonSenseRating", 0);
    setVendorConfirmed(false);
    setCoppa('0');
    setGDPRComplianceLevel('0');
    setHasExternalLLMs(false);
    setValue("lllmProviders", '');
    setValue("llmTraining", false);
    setValue("llmDataShared", false);
    setValue("llmUnder18Treatment", '');
    setValue("llmRestrict", '');
    setValue("processingPurposeSelected", []);
    setProcessingPurposeSelected([]);
    setValue("processingPurposeDescription", '');



    if (currentUser.isSuperAdmin === false) {
      setIsSchoolRecord(true);
    }
    setdataLocationSelected([]);

    setEditOrAddTitle('Add');
    clearErrors();
    setOpen(true);
  };

  const handleCancel = (event, reason) => {
    if (reason && reason === "backdropClick")
      return;
    setOpen(false);
  };

  const handleDeleteCancel = () => {
    setDeleteOpen(false);
  };

  const handleDelete = async() => {
    var data = { id: deleteId, accessToken: accessToken };

    saveApp(data, 'Delete', showError, showSuccess, null, setIsLoading);
    setDeleteOpen(false);
      returnData = await GetPiaData();

    setIsLoading(false);
    applicationData = returnData.applications;
    //processingPurposeItems = returnData[0].processingPurposeList;
    setApplicationDataRows(returnData.applications);
  };
  const closeSuccess = () => {
    setSuccessOpen(false);
  };
  const closeError = () => {
    setErrorOpen(false);
  };

  const handleAuditFrequencyChange = (e) => {

    if (e.target.value === -1) {
      setotherAuditShow(true);
      setValue('auditFrequencyId', e.target.value, { shouldValidate: true });
    }
    else {
      setotherAuditShow(false);
      setValue('auditFrequencyId', e.target.value, { shouldValidate: false }, { required: false });
    }
  }
  const legalBasisForProcessingChange = (e) => {

    setValue('legalBasisForProcessingId', e.target.value, { shouldValidate: true });

  }
  const onSubmitSaveOnly = (data) => {
    onSubmit(data, 1);
  };
  const [currentErrors, setCurrentErrors] = useState([]);
  // const runValidations = (data, mode) => {

  //   validationSchema
  //     .validate(data, { abortEarly: false })
  //     .then((responseData) => {
  //       console.log("no validation errors");
  //       debugger;
  //       //onSubmit(data, mode)
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       console.log(err.name); // ValidationError
  //       console.log(err.errors);
  //       setCurrentErrors(err.errors);
  //     });
  //     debugger;
  //     var isValid = validationSchema.isValid();
  //     var errs = validationSchema.validateSync();
  //     console.log(errs);
  //     //validationSchema.validate(data);
  //   // let errors = Object.values(data);
  //   // //console.log(errors);
  //   // errors.forEach((item) => {
  //   //     console.log(item.message);
  //   // });

  //};
  const getProperUrl = (value) => {
    //if value is undefined, return empty string
    if (value === undefined) {
      return '';
    }
    //debugger;
    //if string does not start with http or https, add it
    if (value !== null && value !== undefined) {
      if (!value.startsWith('http://') && !value.startsWith('https://')) {
        value = "https://" + value;
      }
    }
    // var urlRegex = new RegExp('/^((http):\/\/)/');
    // if(!urlRegex.test(value)) { value = "https://" + value; }
    return value;
  };

  //   const getProperUrlx =(text) => {
  //     var urlRegex = new RegExp(
  //      '([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?', 
  //      'g'
  //     );
  //    return text.replace(urlRegex, (url) => {
  //     if (url.search(/^http[s]?\:\/\//) === -1) {
  //      return 'http://' + url;
  //     } else {
  //       return url;
  //     }
  //    });
  //  }


  const onSubmit = async (data, mode) => {

    if (currentUser.isSuperAdmin) {
      if (window.confirm('Are you sure you want to save this Master Record?')) {

      } else {
        // Do nothing!
        return;
      }
    }

    if (mode !== 1) {
      setOpen(false);
    }

    setIsLoading(true);
    setIsSaving(true);
    data.saving = true;

    data.accessToken = accessToken;

    data.tenantPiaId = tenantPiaId;

    //Handle N/A selections
    data.gradesSelected = gradesSelected;
    if (gradesSelected.indexOf('Select All') !== -1) {
      data.gradesSelected = grades;
    }
    if (gradesNASelected === true) {
      data.gradesSelected = ['N/A'];
    }


    if (staffInfoNASelected === true) {
      data.staffInfoSelected = ['N/A'];
    }
    else {
      //check to see if Select All is selected
      if (staffInfoSelected.indexOf('Select All') !== -1) {
        data.staffInfoSelected = staffItems;
      }
      else {
        data.staffInfoSelected = staffInfoSelected;
      }
    }

    if (studentInfoNASelected === true) {
      data.studentInfoSelected = ['N/A'];
    }
    else {
      //check to see if Select All is selected
      if (studentInfoSelected.indexOf('Select All') !== -1) {
        data.studentInfoSelected = studentItems;
      }
      else {
        data.studentInfoSelected = studentInfoSelected;
      }
    }

    if (parentInfoNASelected === true) {
      data.parentInfoSelected = ['N/A'];
    }
    else {
      //check to see if Select All is selected
      if (parentInfoSelected.indexOf('Select All') !== -1) {
        data.parentInfoSelected = parentItems;
      }
      else {
        data.parentInfoSelected = parentInfoSelected;
      }
    }

    if (alumniInfoNASelected === true) {
      data.alumniInfoSelected = ['N/A'];
    }
    else {
      //check to see if Select All is selected
      if (alumniInfoSelected.indexOf('Select All') !== -1) {
        data.alumniInfoSelected = alumniItems;
      }
      else {
        data.alumniInfoSelected = alumniInfoSelected;
      }
    }

    if (volunteerInfoNASelected === true) {
      data.volunteerInfoSelected = ['N/A'];
    }
    else {
      //check to see if Select All is selected
      if (volunteerInfoSelected.indexOf('Select All') !== -1) {
        data.volunteerInfoSelected = volunteerItems;
      }
      else {
        data.volunteerInfoSelected = volunteerInfoSelected;
      }
    }

    data.areaOfUseSelected = areaOfUseSelected;
    data.dataLocationSelected = dataLocationSelected;
    data.collectionModesSelected = collectionModesSelected;

    //data.cloudHosted = data.cloudHosted === '1';

    data.subcontractorDataProtection = subcontractorDataProtection; //= data.subcontractorDataProtection === '1';
    //forcing using state - was buggy relying on data here - yup issue?

    data.notApproved = notApproved;
    data.approved = approved;

    data.securityBreachInt = securityBreachInt;
    if (data.approved === false) {
      data.approvalDate = null;
    }

    //null out approval date if empty
    if (data.approvalDate === "") {
      data.approvalDate = null;
    }

    //set approver and cloudHostId to null if blank
    data.approverId = data.approverId === '' ? null : data.approverId;
    data.cloudProviderId = data.cloudProviderId === '' ? null : data.cloudProviderId;
    data.cloudProvider = data.cloudProvider === '' ? null : data.cloudProvider;
    data.cloudHosted = cloudHosted;

    if (data.startDate !== null && data.startDate !== '') {
      data.startDate = new Date(data.startDate).toISOString();
    }
    else {
      data.startDate = null;
    }
    if (data.endDate !== null && data.endDate !== '') {
      data.endDate = new Date(data.endDate).toISOString();
    }
    else {
      data.endDate = null;
    }
    if (data.lastAuditDate !== null && data.lastAuditDate !== '') {
      data.lastAuditDate = new Date(data.lastAuditDate).toISOString();
    }
    else {
      data.lastAuditDate = null;
    }
    if (data.approvalDate !== null && data.approvalDate !== '') {
      data.approvalDate = new Date(data.approvalDate).toISOString();
    }
    else {
      data.approvalDate = null;
    }
    data.commonSense = commonSense;
    data.coppa = coppa;
    data.gDPRCompliance = gDPRComplianceLevel;
    data.vendorConfirmed = vendorConfirmed;
    data.policyLastUpdated = policyLastUpdated;

    data.processingPurposeSelected = processingPurposeSelected;
    data.transferSafeguardsSelected = transferSafeguardsSelected;
    data.securityMeasuresSelected = securityMeasuresSelected;
    data.specialCategoryDataSelected = specialCategoryDataSelected;
    data.legalBasisForProcessingId = data.legalBasisForProcessingId === '' ? null : data.legalBasisForProcessingId;
    data.automatedDecisionMaking = automatedDecisionMaking;

    //data.evalUrl = data.evalUrl === '' ? null : data.evalUrl;
    //debugger;
    data.commonSenseScore = data.commonSenseRating === '' ? null : data.commonSenseRating;
    if (data.id === -1) { //add
      // reRender = reRender + 1;
      //setIsLoading(true);
      if (mode !== 1) {

        await saveApp(data, 'Add', showError, showSuccess, setValue, setIsLoading);
        reRender = reRender + 1;
      }
      else {
        await saveApp(data, 'Add', showErrorInDialog, showSuccessInDialog, setValue, setIsLoading);
        reRender = reRender + 1;

      }
    } else {
      if (mode !== 1) {
        await saveApp(data, 'Save', showError, showSuccess, null, setIsLoading);
        //debugger;
        var x = x + 1;
        reRender = reRender + 1;

      }
      else {
        await saveApp(data, 'Save', showErrorInDialog, showSuccessInDialog, setIsLoading);
        //debugger;
        var x = x + 1;
        reRender = reRender + 1;
      }

    }

    returnData = await GetPiaData();

    setIsLoading(false);
    applicationData = returnData.applications;
    //processingPurposeItems = returnData[0].processingPurposeList;
    setApplicationDataRows(returnData.applications);
    //applicationData = null;
  };

  async function GetPiaData() {

    const audience = 'https://piaapplication.azurewebsites.net/';

    const accessToken = localStorage.getItem("userToken");
    setIsLoading(true);
    var response = await fetch('pia?userInfo=' + localStorage.getItem("userEmail"), {
      method: 'GET',
      withCredentials: true,
      credentials: 'include',
      headers: {
        'Authorization': accessToken,
        'Content-Type': 'application/json'
      }
    });


    return response.json();

  };
  const handleSubcontractorRadioButtonChange = (event, setFunction) => {
    setFunction(event.target.value);
  };

  function updateProcessingOtherShow(value) {
    setOtherProcessingPurposeShow(value);

  }
  const MenuProps = useMenuItemProps();

  const HandleChange = (event) => {
    useHandleMultiSelectChange(event, setgradesSelected, setstudentInfoSelected, setstaffInfoSelected, setparentInfoSelected, setalumniInfoSelected, setareaOfUseSelected, setdataLocationSelected, setgradesNASelected, setstudentInfoNASelected, setstaffInfoNASelected, setparentInfoNASelected, setalumniInfoNASelected, setotherDepartmentsShow, setCollectionModesSelected, setVolunteerInfoSelected, setVolunteerInfoNASelected, setProcessingPurposeSelected, updateProcessingOtherShow, setLegalBasisForProcessingInfoSelected, setInternationalTransferFlag, setTransferSafeguardsSelected, setSecurityMeasuresSelected, setSpecialCategoryDataSelected, returnData);
  };

  const titleBoxBackgroundColour = '#1976d21a';

  // const handleCloudHostedChange = (event) => {
  //   setCloudHosted(event.target.checked);
  // };

  // const handleGdprChange = (event) => {
  //   setgDPRCompliant(event.target.checked);
  // };

  const handleinternetPiChange = (event) => {
    setinternetPIPublished(event.target.checked);
  };

  const handleDataBreachCompliantChange = (event) => {
    setdataBreachCompliant(event.target.checked);
  };


  // const handleDataSinglePurposeChange = (event) => {
  //   setDataSinglePurpose(event.target.checked);
  // };

  const handleCloudProviderChange = (event, cloudProviderOtherValue) => {

    setValue('cloudProviderId', event.target.value, { shouldValidate: true });
    setCloudProviderOtherShow(event.target.value === cloudProviderOtherValue);
  }


  const handleApprovedChange = (event, approveIsChecked) => {

    //turn off not approved and clear approver if checking
    if (event.target.checked) {
      setnotApproved(false, setapproved(true));
      setValue('approverId', '');
    }
    else {
      setapproved(false);
    }
  };

  const handleNotApprovedChange = (event) => {
    if (event.target.checked) {
      setapproved(false, setnotApproved(true));
      setValue('notApprovedReason', '');
    }
    else {
      setnotApproved(false);
    }
  };

  // const handleChipChange = (event) => {
  //   const {
  //     target: { value },
  //   } = event;
  //   setareaOfUseSelected(value);
  // };

  const handleChipDelete = (event, value, stateFunction) => {
    event.preventDefault();
    stateFunction((current) => _without(current, value));
  };
  const handleChipDeleteForApplicableDepts = (event, value, stateFunction) => {
    event.preventDefault();
    stateFunction((current) => _without(current, value));
    if (value === 'Other') {
      setotherDepartmentsShow(false);
    }
  };


  // if (loading === false && error !== null) {
  //   return (
  //     <Stack spacing={2}>
  //       <Alert severity="error">Error occured loading PIAs</Alert>
  //     </Stack>
  //   )
  // }

  const CustomDisableInput = styled(TextField)(() => ({
    ".MuiInputBase-input.Mui-disabled": {
      WebkitTextFillColor: "#888",
      color: "#888"
    }
  }));
  const CustomDisableInputSelect = styled(Select)(() => ({
    ".MuiInputBase-input.Mui-disabled": {
      WebkitTextFillColor: "#888",
      color: "#888"
    }
  }));
  function CustomFooter() {
    const apiRef = useGridApiContext();

    return <Button onClick={() => saveGridState(apiRef.current.exportState())}>Save Grid Config</Button>;
  }

  async function saveGridState(state) {

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': accessToken },
      body: JSON.stringify({ state: JSON.stringify(state) })
    };
    const response = await fetch('user/SaveGridState', requestOptions);
  }
  //button group setup
  const buttonGroupOptions = ['Institutional PIAs', 'Master PIAs', 'All PIAs'];


  const handlebgClick = () => {
    console.info(`You clicked ${buttonGroupOptions[selectedIndex]}`);
  };

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setFilterItem(filterItems[index]);
    // if(index === 0){
    //   setFilterItem(filterItems[0]);
    // }
    // if(index === 1){
    //   setFilterItem(filterItems[1]);
    // }
    // if(index === 2){
    //   setFilterItem([2]);
    // }

    setBgOpen(false);
  };

  const setFilterText = (text) => {

    setFilterItem([{ columnField: 'name', operatorValue: 'contains', value: text }]);
  }
  const handlebgToggle = () => {
    setBgOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setBgOpen(false);
  };
  return (

    <div >

      {/* {loading && <DarkBackgroundDiv > */}
      {isLoading && <DarkBackgroundDiv >
        <LoadingOverlay
          active={true}

          spinner={true}
          text="Loading..."
        >
        </LoadingOverlay>
      </DarkBackgroundDiv>}

      {/* {loading && <DarkBackground/>} */}

      <Collapse in={successOpen}  >
        <Stack spacing={2}>
          <Alert severity="success" onClose={() => closeSuccess()}>{successMessage}</Alert>
        </Stack>
      </Collapse>
      <Collapse in={errorOpen}  >
        <Stack spacing={2}>
          <Alert severity="error" onClose={() => closeError()}>An error occured</Alert>
        </Stack>
      </Collapse>

      <Box
        component="span"
        m={1}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid container spacing={1}>

          <Grid item xs={1} border={0}>
            <Typography variant="h3" component="h2">
              PIAs
            </Typography>
          </Grid>
          <Grid style={{ paddingTop: '25px' }} item xs={2.2} border={0}>
            <ButtonGroup variant="contained" ref={anchorRef} aria-label="split button" >
              <Button onClick={handlebgClick}>{buttonGroupOptions[selectedIndex]}</Button>
              <Button
                size="small"
                aria-controls={bgOpen ? 'split-button-menu' : undefined}
                aria-expanded={bgOpen ? 'true' : undefined}
                aria-label="select merge strategy"
                aria-haspopup="menu"
                onClick={handlebgToggle}
              >
                <ArrowDropDownIcon />
              </Button>
            </ButtonGroup>

            <Popper
              sx={{
                zIndex: 1,
              }}
              open={bgOpen}
              anchorEl={anchorRef.current}
              role={undefined}
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === 'bottom' ? 'center top' : 'center bottom',
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList id="split-button-menu" autoFocusItem>
                        {buttonGroupOptions.map((option, index) => (
                          <MenuItem
                            key={option}
                            //disabled={index === 2}
                            selected={index === selectedIndex}
                            onClick={(event) => handleMenuItemClick(event, index)}
                          >
                            {option}
                          </MenuItem>
                        ))}
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </Grid>
          <Grid item xs={7.8} border={0}>
            <TextField
              // disabled={!currentUser.isSuperAdmin}
              style={{ marginTop: '0px' }}
              id="nameFilter"
              name="url"
              label="Begin Typing to Filter by Application Name"
              fullWidth
              margin="dense"
              onChange={(e) => setFilterText(e.target.value)}

            />
          </Grid>
          <Grid item xs={1} style={{ paddingTop: '25px' }}>
            <Button variant="outlined" onClick={addApplication}>Add PIA</Button>
          </Grid>
        </Grid>


      </Box>

      <div>

        <div style={{ height: '70vh', width: '100%' }}>
          <DataGrid
            columns={columns}
            rows={applicationDataRows}
            initialState={initialGridState}
            filterModel={{
              items: filterItem,
            }}
            rowsPerPageOptions={[25, 50, 1000]}

            components={{
              Toolbar: CustomToolbar,
              //Footer: CustomFooter
            }}
          // componentsProps={{
          //   panel: {
          //     anchorEl: filterButtonEl
          //   }
          // }}

          />

        </div>
{/* <PIAFormContent
  register={register}
  control={control}
  setValue={setValue}
  getValues={getValues}
  errors={errors}
  isSuperAdmin={currentUser.isSuperAdmin}
  // ... pass all state and props
/> */}
        <Dialog open={open && !isLoading} onClose={handleCancel}
          fullWidth

          maxWidth="md"
          PaperProps={{
            sx: {
              minHeight: '70%'
            }
          }}

        >
          <DialogTitle
            sx={{ padding: "3px 39px" }}
          >{editOrAddTitle} PIA
            <Typography variant="inherit" sx={{ fontSize: 12, paddingLeft: 2, color: "grey" }} display='inline'>
              * = required &nbsp;&nbsp;<Box sx={{ backgroundColor: "#ecf7eb", display: "inline-block", width: 28, height: 18, border:1, paddingBottom: 1 }}></Box> = duplicated in ROP ares
            </Typography>

            {!isSchoolRecord && !currentUser.isSuperAdmin && (

              <Typography variant="inherit" sx={{ fontSize: 14, paddingLeft: 2, color: "red" }} display='inline'>
                This is a Master Record and cannot be modified
              </Typography>
            )}

          </DialogTitle>
          <DialogContent
            style={{ padding: '2px 30px' }}>
            <div>

            </div>
            <Collapse in={successDialogOpen}  >
              <Stack spacing={2}>
                <Alert severity="success" onClose={() => closeSuccess()}>{successMessage}</Alert>
              </Stack>
            </Collapse>
            <Collapse in={errorDialogOpen}  >
              <Stack spacing={2}>
                <Alert severity="error" onClose={() => closeError()}>An error occured</Alert>
              </Stack>
            </Collapse>
            {/* <DialogContentText>
              </DialogContentText> */}
            <form id='mainForm'>

              <Grid item xs={12} sm={12}>
                <TextField
                  required
                  id="id"
                  name="id"
                  label="ID"
                  fullWidth
                  hidden
                  margin="dense"
                  {...register('id')}

                />

              </Grid>
              <Box px={1} py={0}>

                <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                  onClick={() => setGeneralOpen(!generalOpen)}
                >
                  <Grid container sx={{ justifyContent: "space-between" }} >
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      General Application Information
                    </Typography>
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      {generalOpen ? <RemoveIcon /> : <AddIcon />}
                    </Typography>

                  </Grid>
                </Box>
                <Collapse in={generalOpen} width={'100%'}>
                  <Box sx={{ border: 1 }} px={1} py={2}>
                    {/* 
                        <Box px={3} py={2}>
                        <Paper variant="outlined" > */}
                    <Grid container spacing={2}>
                      <Grid item xs={4}>
                        <CustomDisableInput
                          disabled={!currentUser.isSuperAdmin && !isAdding}
                          required
                          id="name"
                          name="name"
                          label="Application Name"
                          fullWidth
                          margin="dense"
                          {...register('name')}
                          error={errors.name ? true : false}
                        />
                        <Typography variant="inherit" color="error.main">
                          {errors.name?.message}
                        </Typography>
                      </Grid>
                      <Grid item xs={7} sm={7} md={7}>
                        <TextField
                          // disabled={!currentUser.isSuperAdmin}
                          //focused
                          required
                          id="url"
                          name="url"
                          label="Application URL"
                          fullWidth
                          margin="dense"
                          {...register('url')}
                          error={errors.url ? true : false}
                        />
                        <Typography variant="inherit" color="error.main">
                          {errors.url?.message}
                        </Typography>
                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "38px", paddingRight: 0, paddingLeft: "10px" }}>

                        <Button
                          //size={"small"} 
                          sx={{ m: 0, p: 0, minWidth: .6 }}
                          variant="outlined"
                          //underline="hover"
                          //color="inherit"
                          //href={getValues('evalUrl')}

                          href={getProperUrl(getValues('url'))}
                          target="_blank"
                        >
                          Go
                        </Button>
                      </Grid>
                      <Grid item xs={4} sm={4} md={4}>
                        <FormControl sx={{ m: 0, minWidth: 250, maxWidth: 300 }}
                          required
                        >
                          <InputLabel>Vendor</InputLabel>

                          <Controller

                            required
                            name="vendorId"
                            control={control}
                            defaultValue=""
                            // {...register("vendor")}
                            render={({ field: { onChange, value } }) => (
                              <CustomDisableInputSelect
                                disabled={!currentUser.isSuperAdmin && !isAdding}
                                required
                                defaultValue={0}
                                value={value}
                                label="Vendor"
                                onChange={(e) => setValue('vendorId', e.target.value, { shouldValidate: true })}
                              >
                                {vendorsToDisplay.map((vendor, index) => <MenuItem key={index} value={vendor.id}>{vendor.name}</MenuItem>)}

                              </CustomDisableInputSelect>
                            )}
                          />
                        </FormControl>
                        <Typography variant="inherit" color="error.main">
                          {errors.vendorId?.message}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={6} md={6}>
                        <FormGroup>
                          <FormControlLabel control={<Checkbox checked={vendorConfirmed} onChange={handleVendorConfirmedChange} />} label="Vendor Confirmed" />

                        </FormGroup>

                      </Grid>
                      <Grid item xs={2.9} sm={2.9} md={2.9}>
                        <InputLabel sx={{ paddingTop: 1.5, paddingRight: 0, paddingLeft: 0 }}>Common Sense Media:</InputLabel>
                      </Grid>
                      {/* <Grid item xs={5} sm={5} container={true} >

                        <InputLabel sx={{ paddingTop: 1.5, paddingRight: 1, paddingLeft: 1 }}>Common Sense Media Eval:</InputLabel>
                        <TextField
                          //label="Common Sense Media Evaluation"
                          style={{ maxWidth: '100px' }}
                          type="number"


                          //sx={{ m: 1, width: '25ch' }}
                          InputProps={{
                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                            // shrink: true
                          }}
                          id="commonSenseRating"
                          name="commonSenseRating"

                          {...register('commonSenseRating')}
                          error={errors.commonSenseRating ? true : false}
                        />

                        <Typography variant="inherit" color="error.main">
                          {errors.commonSenseRating?.message}
                        </Typography>

                      </Grid> */}
                      <Grid item xs={3.9} sm={3.9} md={3.9} >

                        <FormControl>
                          {/* <FormLabel id="demo-radio-buttons-group-label">Subcontractors required to protect data</FormLabel> */}
                          <RadioGroup
                            row
                            aria-labelledby="demo-radio-buttons-group-label"

                            name="radio-buttons-group"

                          >
                            <ToggleButtonGroup value={commonSense} exclusive onChange={handleCommonSenseChange}>
                              <ToggleButton value={2} selectedColor="green">
                                Pass
                              </ToggleButton>
                              <ToggleButton value={1} selectedColor="orange">
                                Warning
                              </ToggleButton>
                              <ToggleButton value={0} selectedColor="Red">
                                Fail
                              </ToggleButton>
                              <ToggleButton value={4} selectedColor="Grey">
                                N/A
                              </ToggleButton>

                            </ToggleButtonGroup>
                          </RadioGroup>
                        </FormControl>
                        <Typography variant="inherit" color="error.main">
                          {errors.commonSense?.message}
                        </Typography>

                      </Grid>
                      <Grid item xs={4.5} sm={4.5} md={4.5} >
                        <TextField
                          // disabled={!currentUser.isSuperAdmin}
                          //focused
                          //required
                          // InputProps={{
                          //   endAdornment: (
                          //     <Link to={getValues('evalUrl')}>{getValues('evalUrl')}</Link>
                          //   ),
                          // }}
                          id="url"
                          name="url"
                          label="CSM Software Evaluation URL"
                          //onChange={(e) => handleEvalUrlChange(e.target.value)}
                          //onChange={(e) => alert('changing')}
                          //onChange={(e) => setFilterText(e.target.value)}

                          fullWidth
                          //margin="dense"
                          {...register('evalUrl')}
                          error={errors.evalUrl ? true : false}
                        />
                        <Typography variant="inherit" color="error.main">
                          {errors.evalUrl?.message}
                        </Typography>
                      </Grid>
                      <Grid item xs={.7} sm={.7} md={.7} style={{ paddingTop: "30px", paddingRight: 0, paddingLeft: "10px" }}>

                        <Button
                          //size={"small"} 
                          sx={{ m: 0, p: 0, minWidth: 1 }}
                          variant="outlined"
                          //underline="hover"
                          //color="inherit"
                          //href={getValues('evalUrl')}

                          href={getProperUrl(getValues('evalUrl'))}
                          target="_blank"
                        >
                          Go
                        </Button>
                      </Grid>

                      <Grid item xs={2.3} sm={2.3} md={2.3}>
                        <InputLabel sx={{ paddingTop: 1.5, paddingRight: 0, paddingLeft: 0 }}>Compliance GDPR:</InputLabel>
                      </Grid>
                      <Grid item xs={5} sm={5} md={5} >

                        <FormControl>
                          {/* <FormLabel id="demo-radio-buttons-group-label">Subcontractors required to protect data</FormLabel> */}
                          <RadioGroup
                            row
                            aria-labelledby="demo-radio-buttons-group-label"

                            name="radio-buttons-group"
                          >
                            <ToggleButtonGroup value={gDPRComplianceLevel} exclusive onChange={handleGDPRChange}>
                              <ToggleButton value={2} selectedColor="green">
                                Certified
                              </ToggleButton>
                              <ToggleButton value={1} selectedColor="green">
                                Meets Criteria
                              </ToggleButton>
                              <ToggleButton value={0} selectedColor="Red">
                                Unkn
                              </ToggleButton>

                            </ToggleButtonGroup>
                          </RadioGroup>
                        </FormControl>
                        <Typography variant="inherit" color="error.main">
                          {errors.commonSense?.message}
                        </Typography>

                      </Grid>
                      <Grid item xs={1} sm={1.1} md={1.1} >
                        <InputLabel sx={{ paddingTop: 1.5, paddingRight: 0, paddingLeft: 0 }}>COPPA:</InputLabel>
                      </Grid>
                      <Grid item xs={3} sm={3} md={3}>

                        <FormControl>
                          {/* <FormLabel id="demo-radio-buttons-group-label">Subcontractors required to protect data</FormLabel> */}
                          <RadioGroup
                            row
                            aria-labelledby="demo-radio-buttons-group-label"

                            name="radio-buttons-group"
                          >
                            <ToggleButtonGroup value={coppa} exclusive onChange={handleCoppaChange}>
                              <ToggleButton value={2} selectedColor="green">
                                Yes
                              </ToggleButton>
                              <ToggleButton value={1} selectedColor="orange">
                                Unkn
                              </ToggleButton>
                              <ToggleButton value={0} selectedColor="Red">
                                No
                              </ToggleButton>
                              <ToggleButton value={3} selectedColor="Grey">
                                N/A
                              </ToggleButton>

                            </ToggleButtonGroup>
                          </RadioGroup>
                        </FormControl>
                        <Typography variant="inherit" color="error.main">
                          {errors.commonSense?.message}
                        </Typography>

                      </Grid>
                      <Grid item xs={11.5} sm={11.5} md={11.5} paddingRight={0}>
                        <SelfSizingTextField
                          required
                          initialValue={getValues('description')}
                          maxSize={1000}
                          errors={errors.description}
                          register={register}
                          name="description"
                          id="description"
                          label="Description of Application"
                          placeholder="Description of Application"

                        ></SelfSizingTextField>

                      </Grid>
                      <Grid item xs={0.5} sm={0.5} md={0.5} paddingLeft={0.5} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                        <Tooltip title="Description of the application and why private data is needed.">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>

                      {/* < Grid container spacing={2} style={{ paddingBottom: "20px" }}> */}
                      <Grid item xs={5} sm={5}>
                        <MultiSelectWithChips
                          label="Processing Purpose"
                          name="processingPurposeSelected"
                          control={control}
                          backgroundColor="#ecf7eb"
                          value={processingPurposeSelected}
                          infoSelected={processingPurposeSelected}
                          //infoNASelected={processingPurposeNASelected}
                          setinfoSelected={setProcessingPurposeSelected}
                          onChange={HandleChange}
                          handleChipDelete={handleChipDelete}
                          errors={errors.processingPurposeSelected}

                          items={processingPurposes}
                        >
                        </MultiSelectWithChips>

                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                        <Tooltip title="Description:
                                        This field describes why the school uses this application and what educational or operational function it supports. Schools should select the primary purpose(s) that most accurately reflect how the tool is used in practice, adding brief clarification only where necessary.
                                        Why it matters:
                                        GDPR requires schools to demonstrate that personal data is collected for clear, specific, and legitimate purposes. Clear purposes support transparency, data minimization, and accountability.">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>


                       {/* <Grid item xs={11.5} sm={11.5} md={11.5} paddingRight={0}>
                        <SelfSizingTextField
                          required
                          initialValue={getValues('processingPurposeDescription')}
                          maxSize={1000}
                          errors={errors.processingPurposeDescription}
                          register={register}
                          name="description"
                          id="description"
                          label="Description of Application"
                          placeholder="Description of Application"

                        ></SelfSizingTextField>

                      </Grid> */}
                      <Grid item xs={12} sm={12} md={12} paddingRight={0}>
                        <SelfSizingTextField
                          initialValue={getValues('processingPurposeDescription')}
                          maxSize={1000}
                          backgroundColor="#ecf7eb"
                          errors={errors.processingPurposeDescription}
                          register={register}
                          name="processingPurposeDescription"
                          id="processingPurposeDescription"
                          dupefield="processingPurposeDescriptionr"
                          setfunction={setValue}
                          label="Processing Purpose Description"
                          placeholder="Description of the processing purpose."

                        ></SelfSizingTextField>

                      </Grid>
                      <Grid item xs={4} sm={4} md={4}>
                        <FormControl>
                          <FormLabel id="demo-radio-buttons-group-label">Cloud Hosted *</FormLabel>
                          <RadioGroup
                            row
                            aria-labelledby="demo-radio-buttons-group-label"

                            name="radio-buttons-group"
                            {...register('cloudHosted')}
                            onChange={(e) => {

                              handleBooleanRadioButtonChange(e, setCloudHosted);

                            }}
                          >
                            {/* <FormControlLabel {...register('cloudHosted')} disabled={!currentUser.isSuperAdmin && !cloudHosted} key='1' value={'1'} checked={cloudHosted} control={<Radio />} label="Yes" />
                              <FormControlLabel {...register('cloudHosted')} disabled={!currentUser.isSuperAdmin && cloudHosted} key='0' value={'0'} checked={cloudHosted === false} control={<Radio />} label="No" /> */}
                            <FormControlLabel {...register('cloudHosted')} key='1' value={'1'} checked={cloudHosted} control={<Radio />} label="Yes" />
                            <FormControlLabel {...register('cloudHosted')} key='0' value={'0'} checked={cloudHosted === false} control={<Radio />} label="No" />

                          </RadioGroup>
                        </FormControl>
                        <Typography variant="inherit" color="error.main">
                          {errors.cloudHosted?.message}
                        </Typography>

                      </Grid>
                      {/* <Grid item xs={4} sm={4} md={4}>
                          <FormControlLabel control={<Switch
                            checked={cloudHosted}
                            onChange={(e) => handleCloudHostedChange(e, setCloudHosted)}
                            name="cloudHosted"

                          />}
                            label="Cloud Hosted"
                            {...register('cloudHosted')}
                          />

                        </Grid> */}
                      {cloudHosted &&
                        <Grid item xs={4} sm={4}>
                          <FormControl sx={{ m: 0, minWidth: 200, paddingTop: 1 }}>

                            <InputLabel sx={{ paddingTop: 1.5 }}>Cloud Provider</InputLabel>
                            <Controller
                              name="cloudProviderId"
                              control={control}

                              render={({ field: { onChange, value } }) => (
                                <Select id='cloudProviderId'
                                  value={value}
                                  label="Cloud Provider"
                                  onChange={e => handleCloudProviderChange(e, cloudProviderOtherValue)}
                                >
                                  {cloudProviderItems.map((mode, index) => <MenuItem key={index} value={mode.lookupItemId}>{mode.name}</MenuItem>)}

                                </Select>
                              )} />
                          </FormControl>
                          <Typography variant="inherit" color="error.main">
                            {errors.cloudProviderId?.message}
                          </Typography>
                        </Grid>
                      }

                      {cloudHosted && cloudProviderOtherShow &&
                        <Fragment>
                          <Grid item xs={4} sm={4}>
                            <FormControl sx={{ m: 0, minWidth: 200 }}>
                              <TextField
                                // disabled={!currentUser.isSuperAdmin}
                                id="cloudProvider"
                                name="cloudProvider"
                                label="Other Cloud Provider"
                                fullWidth
                                margin="dense"
                                {...register('cloudProvider')}
                                error={errors.cloudProvider ? true : false}
                              />
                            </FormControl>
                            <Typography variant="inherit" color="error.main">
                              {errors.cloudProvider?.message}
                            </Typography>


                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                            <Tooltip title="What cloud service is hosting the application? ">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>
                        </Fragment>
                      }
                     
                      {/* <Grid item xs={12} sm={12}></Grid> */}
                      <Grid item xs={12} sm={12} md={12} paddingTop={1}>
                        <Typography variant="inherit" >
                          To Be Completed by Organization &nbsp;&nbsp;
                          {/* <Tooltip title="Description
                                          These fields identify personal information that is processed by the application. Schools should select all applicable groups whose data may be shared with or processed by the vendor.  This field captures the types of personal information processed by the application (for example: first name, lastname, email....). Schools should select all data categories that realistically apply based on actual use of the tool.  These fields are identical and mirror the fields in the data collection section.  If you edit them in that section, they will be updated here, and vice-versa.


                                        Why it matters
                                            GDPR requires schools to document which groups of individuals are affected by data processing activities. This ensures appropriate safeguards are applied, particularly where children’s data is involved.  Documenting data categories supports the principles of data minimization and proportionality. It also helps schools understand privacy risk and respond accurately to access or disclosure requests.">
                            <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                          </Tooltip> */}
                        </Typography>

                      </Grid>
                      <Grid container border={0} item xs={12} sm={12} md={12} style={{ paddingTop: "10px", paddingLeft: "20px", paddingBottom: "10px" }} >
                        <Grid container border={1} item xs={12} sm={12} md={12} style={{ paddingTop: "10px", paddingLeft: "20px", paddingBottom: "10px" }} >
                          {/* <Grid container border={1} style={{ paddingTop: "10px", paddingLeft: "10px", paddingBottom: "10px" }} > */}

                          <Grid item xs={4} sm={4}  >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <Box sx={{ width: '100%',border: 1, borderColor: 'red', borderRadius: 1, padding: 1 }}>
                                <DatePicker
                                  sx={{
                                    width: '100%',
                                    '& .MuiInputLabel-root': {
                                      color: 'red',
                                      '&.Mui-focused': { color: 'violet' },
                                    },
                                    '& .MuiOutlinedInput-root': {
                                      '& fieldset': { borderColor: 'red' },
                                      '&:hover fieldset': { borderColor: 'red' },
                                      '&.Mui-focused fieldset': { borderColor: 'red !important' },
                                    },
                                    '& .MuiSvgIcon-root': { color: 'red' },
                                  }}
                                  id="startDate"
                                  name="startDate"
                                  label="Date Started"
                                  {...register('startDate')}
                                  value={startDate}
                                  onChange={(newValue) => {
                                    setStartDate(newValue);
                                    setValue("startDate", newValue);
                                  }}
                                  renderInput={(params) => <TextField  {...params} />}
                                />
                              </Box>
                            </LocalizationProvider>
                            <Typography variant="inherit" color="error.main">
                              {errors.startDate?.message}
                            </Typography>
                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                            <Tooltip title="The date you started using the application.">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>
                          <Grid item xs={6} sm={4}  >
                            <LocalizationProvider xs={6} dateAdapter={AdapterDayjs}>
                              <Box sx={{ width: '100%',border: 1, borderColor: 'red', borderRadius: 1, padding: 1 }}>
                              <DatePicker
                                id="endDate"
                                name="endDate"
                                label="Date Ended"
                                {...register('endDate')}
                                value={endDate}
                                onChange={(newValue) => {
                                  setEndDate(newValue);
                                  setValue("endDate", newValue);
                                }}
                                renderInput={(params) => <TextField  {...params} />}
                              />
                              </Box>
                            </LocalizationProvider>
                            <Typography variant="inherit" color="error.main">
                              {errors.endDate?.message}
                            </Typography>
                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                            <Tooltip title="The date you stopped using the application - needed for historical reporting.">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>



                          <Grid item xs={12} />
                          {!(!currentUser.isSuperAdmin || true) &&

                            <Grid item xs={6} sm={6}>
                              <FormControl sx={{ m: 0, minWidth: 200 }}>
                                <InputLabel>Institution Point of Contact </InputLabel>
                                <Controller
                                  name="itOwnerId"
                                  control={control}
                                  defaultValue=""
                                  // {...register("vendor")}
                                  render={({ field: { onChange, value } }) => (
                                    <Select
                                      defaultValue={0}
                                      value={value}
                                      label="Institution Point of Contact"
                                      onChange={(e) => setValue('itOwnerId', e.target.value, { shouldValidate: true })}
                                    >
                                      {itOwners.map((owner, index) => <MenuItem key={index} value={owner.id}>{owner.name}</MenuItem>)}

                                    </Select>
                                  )}
                                />
                              </FormControl>
                              <Typography variant="inherit" color="error.main">
                                {errors.itOwner?.message}
                              </Typography>
                            </Grid>
                          }
                          <Grid item xs={5} sm={5}>
                            <FormControl sx={{ m: 0, minWidth: 200 }}>
                              {/* <InputLabel>Collection Mode </InputLabel>
                           <Controller
                              name="collectionModeId"
                              control={control}
                              defaultValue=""
                              // {...register("vendor")}
                              render={({ field: { onChange, value } }) => (
                                <Select
                                  defaultValue={0}
                                  value={value}
                                  label="Collection Mode"
                                  onChange={(e) => setValue('collectionModeId', e.target.value, { shouldValidate: true })}
                                >
                                  {collectionModes.map((mode, index) => <MenuItem key={index} value={mode.lookupItemId}>{mode.name}</MenuItem>)}

                                </Select>
                              )}
                            /> */}
                              {/*
                          </FormControl> */}
                              {/* <Typography variant="inherit" color="error.main">
                            {errors.collectionModeId?.message}
                          </Typography> */}
                              <MultiSelectWithChips
                                borderColor="red"
                                label="Collection Mode"
                                name="collectionModesSelected"
                                control={control}
                                value={collectionModesSelected}
                                infoSelected={collectionModesSelected}
                                //infoNASelected={studentInfoNASelected}
                                setinfoSelected={setCollectionModesSelected}
                                onChange={HandleChange}
                                handleChipDelete={handleChipDelete}
                                errors={errors.collectionModesSelected}

                                items={collectionModeItems}
                              >
                              </MultiSelectWithChips>
                            </FormControl>
                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                            <Tooltip title="How is the student data transfered to the third party application?">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>
                          {collectionModesSelected.indexOf('Other') !== -1 && (
                            <Grid item xs={6} sm={6} md={6} lg={6} >
                              <FormControl sx={{ m: 0, minWidth: 400 }}>
                                <TextField
                                  // disabled={!currentUser.isSuperAdmin}
                                  id="collectionModeOther"
                                  name="collectionModeOther"
                                  label="Other Collection Mode"
                                  fullWidth
                                  margin="dense"
                                  {...register('collectionModeOther')}
                                  error={errors.collectionModeOther ? true : false}
                                />
                              </FormControl>
                              <Typography variant="inherit" color="error.main">
                                {errors.collectionModeOther?.message}
                              </Typography>
                            </Grid>
                          )}
                          <Grid item xs={5} sm={5}>
                            <MultiSelectWithChips
                              borderColor="red"
                              label="Applicable Grades"
                              name="gradesSelected"
                              control={control}
                              value={gradesSelected}
                              infoSelected={gradesSelected}
                              infoNASelected={gradesNASelected}
                              setinfoSelected={setgradesSelected}
                              onChange={HandleChange}
                              handleChipDelete={handleChipDelete}
                              errors={errors.gradesSelected}

                              items={grades}
                            >
                            </MultiSelectWithChips>

                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                            <Tooltip title="What grade are using the application - important for reporting.">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>
                          <Grid item xs={5} sm={5}>
                            <MultiSelectWithChips
                              borderColor="red"
                              label="Department of Responsibility"
                              name="areaOfUseSelected"
                              control={control}
                              backgroundColor="#ecf7eb"
                              value={areaOfUseSelected}
                              infoSelected={areaOfUseSelected}
                              //infoNASelected={studentInfoNASelected}
                              setinfoSelected={setareaOfUseSelected}
                              onChange={HandleChange}
                              handleChipDelete={handleChipDeleteForApplicableDepts}
                              errors={errors.areaOfUseItems}

                              items={areaOfUseItems}
                            >
                            </MultiSelectWithChips>


                            <Typography variant="inherit" color="error.main">
                              {errors.areaOfUseSelected?.message}
                            </Typography>
                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                            <Tooltip title="What department(s) are using this software?">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>
                          {otherDepartmentsShow && (
                            <Grid item xs={6} style={{ paddingTop: 25 }} >

                              <TextField

                                // disabled={!currentUser.isSuperAdmin}
                                InputLabelProps={{ shrink: true }}
                                id="applicableDepartmentsOther"
                                name="applicableDepartmentsOther"
                                label="Other Applicable Departments"
                                fullWidth
                                placeholder="Other Applicable Departments"
                                {...register('applicableDepartmentsOther')}
                              />

                              <Typography variant="inherit" color="error.main">
                                {errors.applicableDepartmentsOther?.message}
                              </Typography>

                            </Grid>
                          )}




                          <Grid item xs={4.5} sm={4.5} md={4.5} style={{ paddingTop: 10 }} >
                            <TextField
                              sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: 'red' } }}

                              // disabled={!currentUser.isSuperAdmin}
                              //focused
                              //required
                              // InputProps={{
                              //   endAdornment: (
                              //     <Link to={getValues('evalUrl')}>{getValues('evalUrl')}</Link>
                              //   ),
                              // }}
                              id="url"
                              name="url"
                              label="Contract URL"
                              //onChange={(e) => handleEvalUrlChange(e.target.value)}
                              //onChange={(e) => alert('changing')}
                              //onChange={(e) => setFilterText(e.target.value)}

                              fullWidth
                              //margin="dense"
                              {...register('contractUrl')}
                              error={errors.contractUrl ? true : false}
                            />
                            <Typography variant="inherit" color="error.main">
                              {errors.contractUrl?.message}
                            </Typography>
                          </Grid>
                          <Grid item xs={.7} sm={.7} md={.7} style={{ paddingTop: "30px", paddingRight: 0, paddingLeft: "10px" }}>

                            <Button
                              //size={"small"} 
                              sx={{ m: 0, p: 0, minWidth: 1 }}
                              variant="outlined"
                              //underline="hover"
                              //color="inherit"
                              //href={getValues('evalUrl')}

                              href={getProperUrl(getValues('contractUrl'))}
                              target="_blank"
                            >
                              Go
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={11}>

                        <SelfSizingTextField
                          required={false}
                          initialValue={getValues('generalApplicationNotes')}
                          maxSize={2000}
                          errors={errors.generalApplicationNotes}
                          register={register}
                          name="generalApplicationNotes"
                          id="generalApplicationNotes"
                          label="General Application Notes"
                          placeholder="General Application Notes"

                        ></SelfSizingTextField>

                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                        <Tooltip title="Any other general information that is needed to be kept by the school.">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>

                    </Grid>
                    {/* </Paper>
                        </Box>*/}
                  </Box>
                </Collapse>

                <Grid item xs={12} />
                <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                  onClick={() => setDataCollectionOpen(!dataCollectionOpen)}
                >
                  <Grid container sx={{ justifyContent: "space-between" }}>
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      Data Collection
                    </Typography>
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      {dataCollectionOpen ? <RemoveIcon /> : <AddIcon />}

                    </Typography>
                  </Grid>
                </Box>
                <Collapse in={dataCollectionOpen} width={'100%'}>
                  <Box sx={{ border: 1 }} px={1} py={2}>
                    <Grid container spacing={2}>
                      {/* <Grid item xs={12} /> */}
                      <Grid item xs={5}>
                        <MultiSelectWithChips
                          label="Student Information"
                          backgroundColor="#ecf7eb"
                          name="studentInfoSelected"
                          control={control}
                          value={studentInfoSelected}
                          infoSelected={studentInfoSelected}
                          infoNASelected={studentInfoNASelected}
                          setinfoSelected={setstudentInfoSelected}
                          onChange={HandleChange}
                          handleChipDelete={handleChipDelete}
                          errors={errors.studentInfoSelected}
                          items={studentItems}
                        >
                        </MultiSelectWithChips>
                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                        <Tooltip title="Private student data fields that are sent to the 3rd party application. ">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>
                      <Grid item xs={5} >
                        <MultiSelectWithChips
                          label="Employee Information "
                          backgroundColor="#ecf7eb"
                          name="staffInfoSelected"
                          control={control}
                          value={staffInfoSelected}
                          infoSelected={staffInfoSelected}
                          infoNASelected={staffInfoNASelected}
                          setinfoSelected={setstaffInfoSelected}
                          onChange={HandleChange}
                          handleChipDelete={handleChipDelete}
                          errors={errors.staffInfoSelected}
                          items={staffItems}
                        >
                        </MultiSelectWithChips>

                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                        <Tooltip title="Private employee data fields that are sent to the 3rd party application. ">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>
                      <Grid item xs={5}>
                        <MultiSelectWithChips
                          label="Parent/Guardian Information"
                          backgroundColor="#ecf7eb"
                          name="parentInfoSelected"
                          control={control}
                          value={parentInfoSelected}
                          infoSelected={parentInfoSelected}
                          infoNASelected={parentInfoNASelected}
                          setinfoSelected={setparentInfoSelected}
                          onChange={HandleChange}
                          handleChipDelete={handleChipDelete}
                          errors={errors.parentInfoSelected}
                          items={parentItems}
                        >
                        </MultiSelectWithChips>

                        <Typography variant="inherit" color="error.main">
                          {errors.parentInfoSelected?.message}
                        </Typography>

                      </Grid>
                      <Grid item xs={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                        <Tooltip title="Private Parent/Guardian data fields that are sent to the 3rd party application.  ">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>
                      <Grid item xs={5}>
                        <MultiSelectWithChips
                          label="Alumni Information"
                          backgroundColor="#ecf7eb"
                          name="alumniInfoSelected"
                          control={control}
                          value={alumniInfoSelected}
                          infoSelected={alumniInfoSelected}
                          infoNASelected={alumniInfoNASelected}
                          setinfoSelected={setalumniInfoSelected}
                          onChange={HandleChange}
                          handleChipDelete={handleChipDelete}
                          errors={errors.alumniInfoSelected}
                          items={alumniItems}
                        >
                        </MultiSelectWithChips>

                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                        <Tooltip title="Private alumni data fields that are sent to the 3rd party application. ">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>
                      <Grid item xs={5}>
                        <MultiSelectWithChips
                          label="Volunteer Information"
                          backgroundColor="#ecf7eb"
                          name="volunteerInfoSelected"
                          control={control}
                          value={volunteerInfoSelected}
                          infoSelected={volunteerInfoSelected}
                          infoNASelected={volunteerInfoNASelected}
                          setinfoSelected={setVolunteerInfoSelected}
                          onChange={HandleChange}
                          handleChipDelete={handleChipDelete}
                          errors={errors.volunteerInfoSelected}
                          items={volunteerItems}
                        >
                        </MultiSelectWithChips>

                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                        <Tooltip title="Private volunteer data fields that are sent to the 3rd party application.  ">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>

                      <Grid item xs={11} >
                        <SelfSizingTextField
                          // disabled={!currentUser.isSuperAdmin}
                          initialValue={getValues('other')}
                          errors={errors.other}
                          register={register}
                          maxSize={2000}
                          name="other"
                          id="other"
                          label="Other"
                          placeholder="Cookies, other information collected etc."
                        ></SelfSizingTextField>

                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                        <Tooltip title="Cookies, IP addresses, or anything else tracked by the application. ">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>

                      <Grid item xs={11}>

                        <SelfSizingTextField
                          required={false}
                          initialValue={getValues('dataCollectionNotes')}
                          maxSize={2000}
                          errors={errors.dataCollectionNotes}
                          register={register}
                          name="dataCollectionNotes"
                          id="dataCollectionNotes"
                          label="Data Collection Notes"
                          placeholder="Data Collection Notes"

                        ></SelfSizingTextField>

                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                        <Tooltip title="Any other data collection information that is needed to be kept by the school.">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>



                    </Grid>
                  </Box>
                </Collapse>
                <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                  onClick={() => setDataProtectionOpen(!dataProtectionOpen)}
                >
                  <Grid container sx={{ justifyContent: "space-between" }}>
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      Data Protection
                    </Typography>
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      {dataProtectionOpen ? <RemoveIcon /> : <AddIcon />}

                    </Typography>

                  </Grid>
                </Box>
                <Collapse in={dataProtectionOpen} width={'100%'}>
                  <Box sx={{ border: 1 }} px={1} py={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={11} >
                        <SelfSizingTextField
                          // disabled={!currentUser.isSuperAdmin}
                          initialValue={getValues('privacyNotification')}
                          errors={errors.privacyNotification}
                          register={register}
                          maxSize={1000}
                          name="privacyNotification"
                          id="privacyNotification"
                          label="Privacy Notification"
                          placeholder="How does the vendor notify customers of privacy policy changes?"
                        ></SelfSizingTextField>
                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                        <Tooltip title="How does the vendor notify customers of a change in the data policy?">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>
                      <Grid item xs={4} sm={4} md={4}>
                        <LocalizationProvider xs={6} dateAdapter={AdapterDayjs}>
                          <DatePicker
                            inputFormat="MMM-YYYY"
                            views={['month', 'year']}
                            id="policyLastUpdated"
                            name="policyLastUpdated"
                            label="Privacy Policy Last Updated"
                            //{...register('policyLastUpdated')}
                            value={policyLastUpdated}

                            onChange={(newValue) => {
                              //debugger;
                              setPolicyLastUpdated(newValue);
                            }}
                            renderInput={(params) => <TextField  {...params} />}
                          />
                        </LocalizationProvider>

                        <Typography variant="inherit" color="error.main">
                          {errors.policyLastUpdated?.message}
                        </Typography>
                      </Grid>

                      <Grid item xs={11} >
                        <SelfSizingTextField
                          // disabled={!currentUser.isSuperAdmin}
                          initialValue={getValues('subcontractors')}
                          errors={errors.subcontractors}
                          register={register}
                          maxSize={1000}
                          name="subcontractors"
                          id="subcontractors"
                          label="Subcontractors"
                          placeholder="List subcontractors who have access to data"
                        ></SelfSizingTextField>
                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                        <Tooltip title="The list (or a link to the list) of the vetted subcontractors.">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>

                      <Grid item xs={12} sm={12} md={12}>

                        <FormControl>
                          <FormLabel id="demo-radio-buttons-group-label">Has the organization experienced a privacy breach in the past?</FormLabel>
                          <RadioGroup
                            row
                            aria-labelledby="demo-radio-buttons-group-label"

                            name="radio-buttons-group"
                            //{...register('subcontractorDataProtection')}
                            onChange={(e) => handleSecurityBreachChange(e, setSecurityBreachInt)}
                          >
                            <FormControlLabel {...register('securityBreachInt')} key='1' value={'1'} checked={securityBreachInt == '1'} control={<Radio />} label="Yes" />
                            <FormControlLabel {...register('securityBreachInt')} key='0' value={'0'} checked={securityBreachInt == '0'} control={<Radio />} label="No" />
                            <FormControlLabel {...register('securityBreachInt')} key='-1' value={'-1'} checked={securityBreachInt == '-1'} control={<Radio />} label="Unknown" />

                          </RadioGroup>
                        </FormControl>
                        <Typography variant="inherit" color="error.main">
                          {errors.securityBreachInt?.message}
                        </Typography>
                      </Grid>

                      {securityBreachInt == '1' && (<Grid item xs={12} sm={12} md={12}>
                        <SelfSizingTextField
                          // disabled={!currentUser.isSuperAdmin}
                          initialValue={getValues('securityBreachDescription')}
                          errors={errors.securityBreachDescription}
                          register={register}
                          maxSize={1000}
                          name="securityBreachDescription"
                          id="securityBreachDescription"
                          label="Security Breach Description"
                          placeholder="If yes, please explain the incident"
                        ></SelfSizingTextField>
                      </Grid>)}

                      <Grid item xs={11} >
                        <SelfSizingTextField
                          // disabled={!currentUser.isSuperAdmin}
                          initialValue={getValues('privacyPracticeReview')}
                          errors={errors.privacyPracticeReview}
                          register={register}
                          maxSize={1000}
                          name="privacyPracticeReview"
                          id="privacyPracticeReview"
                          label="Privacy Practice Review"
                          placeholder="How often does the vendor review its privacy practices?"
                        ></SelfSizingTextField>
                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                        <Tooltip title="How often does the vendor review its privacy practices?.">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>


                      <Grid item xs={11}>
                        <SelfSizingTextField
                          // disabled={!currentUser.isSuperAdmin}
                          initialValue={getValues('vendorSaleAssurance')}
                          errors={errors.vendorSaleAssurance}
                          register={register}
                          maxSize={1000}
                          name="vendorSaleAssurance"
                          id="vendorSaleAssurance"
                          label="Vendor Sale Assurance"
                          placeholder="Is there an assurance that the privacy policy will stay in place until renewal if the vendor is sold?"
                        ></SelfSizingTextField>
                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                        <Tooltip title="Is there an assurance that the privacy policy for the school’s data will stay in place until renewal if the vendor is sold?">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>
                      <Grid item xs={11}>

                        <SelfSizingTextField
                          required={false}
                          initialValue={getValues('dataProtectionNotes')}
                          maxSize={2000}
                          errors={errors.dataProtectionNotes}
                          register={register}
                          name="dataProtectionNotes"
                          id="dataProtectionNotes"
                          label="Data Protection Notes"
                          placeholder="Data Protection Notes"

                        ></SelfSizingTextField>

                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                        <Tooltip title="Any other data protection information that is needed to be kept by the school.">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>

                    </Grid>
                  </Box>
                </Collapse>
                <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                  onClick={() => setDataHandlingOpen(!dataHandlingOpen)}
                >
                  <Grid container sx={{ justifyContent: "space-between" }}>
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      Data Handling
                    </Typography>
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      {dataHandlingOpen ? <RemoveIcon /> : <AddIcon />}

                    </Typography>

                  </Grid>
                </Box>

                <Collapse in={dataHandlingOpen} width={'100%'}>
                  <Box sx={{ border: 1 }} px={1} py={2}>
                    <Grid container spacing={2}>

                      <Grid item xs={11}>

                        <FormControl>
                          <FormLabel id="demo-radio-buttons-group-label">Vendor ensures that the data is not used for anything other than the stated purpose &nbsp;</FormLabel>
                          <RadioGroup
                            row
                            aria-labelledby="demo-radio-buttons-group-label"

                            name="radio-buttons-group"
                            //{...register('subcontractorDataProtection')}
                            onChange={(e) => handleBooleanRadioButtonChange(e, setDataSinglePurpose)}
                          >

                            {/* <FormControlLabel {...register('dataSinglePurpose')} disabled={!currentUser.isSuperAdmin && !dataSinglePurpose} key='1' value={'1'} checked={dataSinglePurpose} control={<Radio />} label="Yes" />
                              <FormControlLabel {...register('dataSinglePurpose')} disabled={!currentUser.isSuperAdmin && dataSinglePurpose} key='0' value={'0'} checked={dataSinglePurpose === false} control={<Radio />} label="No" /> */}
                            <FormControlLabel {...register('dataSinglePurpose')} key='1' value={'1'} checked={dataSinglePurpose} control={<Radio />} label="Yes" />
                            <FormControlLabel {...register('dataSinglePurpose')} key='0' value={'0'} checked={dataSinglePurpose === false} control={<Radio />} label="No" />

                          </RadioGroup>
                        </FormControl>
                        <Tooltip paddingLeft={"10px"} title="The vendor assures that the data is being used for anything that is not descrived in the privacy agreement, including targetted advertising or that the data is being sold">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                        <Typography variant="inherit" color="error.main" >
                          {errors.dataSinglePurpose?.message}
                        </Typography>
                        {/* <FormControlLabel control={<Switch
                            checked={dataSinglePurpose ?? false}
                            onChange={handleDataSinglePurposeChange}
                          />}
                            label="Vendor ensures that the data is not used for anything other than the stated purpose"
                            {...register('dataSinglePurpose')}
                          /> */}
                      </Grid>


                      <Grid item xs={5} sm={5}>
                        <MultiSelectWithChips
                          label="Where does the data reside?"
                          backgroundColor="#ecf7eb"
                          name="dataLocationSelected"
                          control={control}
                          value={dataLocationSelected}
                          infoSelected={dataLocationSelected}
                          //infoNASelected={studentInfoNASelected}
                          setinfoSelected={setdataLocationSelected}
                          onChange={HandleChange}
                          handleChipDelete={handleChipDelete}
                          errors={errors.dataLocationSelected}

                          items={dataLocationItems}
                        >
                        </MultiSelectWithChips>
                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                        <Tooltip title="Where is the data housed - it could be multiple countries.">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>
                      {dataLocationSelected.indexOf('Other') !== -1 && (
                        <Grid item xs={6} sm={6} md={6} style={{ paddingTop: 25 }} >

                          <TextField


                            InputLabelProps={{ shrink: true }}
                            id="dataLocationOther"
                            name="dataLocationOther"
                            label="Other Data Location"
                            fullWidth
                            placeholder="Other Data Location"
                            {...register('dataLocationOther')}
                          />

                          <Typography variant="inherit" color="error.main">
                            {errors.dataLocationOther?.message}
                          </Typography>

                        </Grid>


                      )}
                      {/* <FormControl sx={{ m: 0, width: 250 }}>
                          <InputLabel> Where does the data reside? </InputLabel>
                          <Controller
                            name="dataLocationSelected"
                            control={control}
                            defaultValue=""
                            render={({ field: { onChange, value } }) => (
                              <Select
                                // disabled={!currentUser.isSuperAdmin}
                                multiple
                                MenuProps={MenuProps}
                                name="dataLocationSelected"
                                value={dataLocationSelected}
                                label="Where does the data reside?"
                                input={<OutlinedInput label="Where does the data reside?" />}
                                onChange={HandleChange}
                                renderValue={(selected) => selected.join(',')}
                              >
                                {dataLocationItems.map((item) => (
                                  <MenuItem value={item} key={item} >
                                    <Switch checked={dataLocationSelected.indexOf(item) > -1} />
                                    {<ListItemText primary={item} />}
                                  </MenuItem>
                                ))}

                              </Select>
                            )}
                          />
                        </FormControl>
                        <Typography variant="inherit" color="error.main">
                          {errors.dataLocationSelected?.message}
                        </Typography>
                      </Grid> */}
                      <Grid item xs={11} >
                        <SelfSizingTextField
                          // disabled={!currentUser.isSuperAdmin}
                          backgroundColor="#ecf7eb"
                          initialValue={getValues('dataRetentionPolicy')}
                          errors={errors.dataRetentionPolicy}
                          register={register}
                          maxSize={2500}
                          name="dataRetentionPolicy"
                          id="dataRetentionPolicy"
                          dupefield="dataRetentionPolicyr"
                          setfunction={setValue}
                          label="Data Retention Policy"
                          placeholder="Describe the data retention policy for active and inactive accounts"
                        ></SelfSizingTextField>
                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                        <Tooltip title="What is the data retention policy for the country - for active accounts and for inactive accounts.">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>
                      {/* <Grid item xs={12} sm={12} md={12}>
                        <SelfSizingTextField
                          // disabled={!currentUser.isSuperAdmin}
                          initialValue={getValues('dataRetentionLength')}
                          errors={errors.dataRetentionLength}
                          register={register}
                          maxSize={1000}
                          name="dataRetentionLength"
                          id="dataRetentionLength"
                          label="Data Retention Length"
                          placeholder="How long is the data retained?"
                        ></SelfSizingTextField>
                      </Grid> */}

                      <Grid item xs={11} >
                        <SelfSizingTextField
                          // disabled={!currentUser.isSuperAdmin}
                          backgroundColor="#ecf7eb"
                          initialValue={getValues('dataAfterDiscontinuing')}
                          errors={errors.dataAfterDiscontinuing}
                          register={register}
                          maxSize={2500}
                          name="dataAfterDiscontinuingr"
                          id="dataAfterDiscontinuingr"
                          label="Data Discontinuance"
                          dupefield="dataAfterDiscontinuing"
                          setfunction={setValue}
                          placeholder="What happens to the data if relationship with the software vendor is discontinued."
                        ></SelfSizingTextField>
                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                        <Tooltip title="How is private data removed from the application if the school is no longer a client?">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>
                      <Grid item xs={11} >

                        <SelfSizingTextField
                          required={false}
                          initialValue={getValues('dataHandlingNotes')}
                          maxSize={2000}
                          errors={errors.dataHandlingNotes}
                          register={register}
                          name="dataHandlingNotes"
                          id="dataHandlingNotes"
                          label="Data Handling Notes"
                          placeholder="Data Handling Notes"

                        ></SelfSizingTextField>

                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                        <Tooltip title="Any other data handling information that is needed to be kept by the school.">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </Box>
                </Collapse>
                <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                  onClick={() => setOtherOpen(!otherOpen)}
                >
                  <Grid container sx={{ justifyContent: "space-between" }}>
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      Compliance
                    </Typography>
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      {otherOpen ? <RemoveIcon /> : <AddIcon />}

                    </Typography>

                  </Grid>
                </Box>
                <Collapse in={otherOpen} width={'100%'}>
                  <Box sx={{ border: 1 }} px={1} py={2}>
                    {/* <Typography variant="inherit">
                        Hover over items to show expanded information
                      </Typography> */}

                    <Grid container spacing={2}>
                      <Grid item xs={6} sm={6} md={6}>

                        <FormControl>
                          <Tooltip arrow sx={{ padding: 0 }} placement="bottom-start" title=" The General Data Protection Regulation (GDPR) is the toughest privacy and security law in the world. Though it was drafted and passed by the European Union (EU), it imposes obligations onto organizations anywhere, so long as they target or collect data related to people in the EU.">
                            <FormLabel id="gdpr-label">Software is GDPR Compliant</FormLabel>
                          </Tooltip>
                          <RadioGroup
                            row
                            aria-labelledby="demo-radio-buttons-group-label"

                            name="gDPRCompliant"
                            {...register('gDPRCompliant')}
                            //onChange={handleGdprChange}
                            onChange={(e) => {

                              handleBooleanRadioButtonChange(e, setgDPRCompliant);

                            }}
                          >

                            <FormControlLabel {...register('gDPRCompliant')} key='1' value={'1'} checked={gDPRCompliant} control={<Radio />} label="Yes" />
                            <FormControlLabel {...register('gDPRCompliant')} key='0' value={'0'} checked={gDPRCompliant === false} control={<Radio />} label="No" />

                          </RadioGroup>
                        </FormControl>

                      </Grid>



                      {/* <Grid item xs={6} sm={6} md={6}>
                          <Tooltip arrow sx={{ padding: 0 }} placement="bottom-start" title=" The General Data Protection Regulation (GDPR) is the toughest privacy and security law in the world. Though it was drafted and passed by the European Union (EU), it imposes obligations onto organizations anywhere, so long as they target or collect data related to people in the EU.">
                            <FormControlLabel control={<Switch
                              // disabled={!currentUser.isSuperAdmin}
                              checked={gDPRCompliant ?? false}
                              onChange={handleGdprChange}
                              name="gDPRCompliant"

                            />}
                              label="Software is compliant with GDPR"
                              {...register('gDPRCompliant')}
                            />
                          </Tooltip>

                        </Grid> */}
                      {gDPRCompliant &&
                        <Fragment>
                          <Grid item xs={12} sm={12} md={12}>
                            <Typography variant="inherit" >
                              <p>
                                This software is GDPR compliant, which ensures that it meets various
                                essential criteria outlined in the privacy impact assessment. Being
                                GDPR compliant indicates that the software provider has implemented
                                several measures to protect the privacy and security of student data.
                              </p>
                              <p>
                                These measures include:
                              </p>
                              <p>
                                Privacy Training Plan: The software provider has a comprehensive
                                privacy training plan in place for its employees, ensuring they
                                understand the importance of data protection and privacy regulations.
                              </p>
                              <p>
                                Security Breach Plan: The software provider has established a robust
                                security breach plan to promptly detect, respond to, and mitigate any
                                potential data breaches or unauthorized access incidents.
                              </p>
                              <p>
                                Subcontractor Vetting: All subcontractors and third-party service
                                providers associated with the software have been thoroughly vetted to
                                ensure they adhere to stringent privacy standards.
                              </p>
                              <p>
                                Privacy Audit Cycle: The software provider follows a reasonable cycle
                                to conduct privacy audits, verifying that data protection practices
                                remain up to date and compliant with relevant regulations.
                              </p>
                              <p>
                                Backup and Storage Plan: The software provider maintains a sufficient
                                backup and storage plan to safeguard student data, ensuring its
                                availability and integrity.
                              </p>
                              <p>
                                Security Tools: The software incorporates various security tools, such
                                as Security Information and Event Management (SIEM), encrypted data
                                transit, and robust password complexity requirements, to protect
                                against unauthorized access and ensure data confidentiality.
                              </p>
                            </Typography>
                          </Grid>
                        </Fragment>
                      }
                      {!gDPRCompliant &&
                        <Fragment>
                          <Grid item xs={12} sm={12} md={12}>
                            <Typography variant="inherit" >
                              The Vendor only needs to fill these sections below if they are not GDPR compliant
                            </Typography>
                          </Grid>

                          <Grid item xs={11} >
                            <SelfSizingTextField
                              // disabled={!currentUser.isSuperAdmin}
                              initialValue={getValues('privacyTraining')}
                              errors={errors.privacyTraining}
                              register={register}
                              maxSize={1000}
                              name="privacyTraining"
                              id="privacyTraining"
                              label="Privacy Training"
                              placeholder="How does the vendor ensure employees are trained to handle private data?"
                            ></SelfSizingTextField>
                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                            <Tooltip title="How does the vendor ensure employees are trained to handle private data?">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>

                          <Grid item xs={11}>
                            <SelfSizingTextField
                              // disabled={!currentUser.isSuperAdmin}
                              initialValue={getValues('securityBreachPlan')}
                              errors={errors.securityBreachPlan}
                              register={register}
                              maxSize={2000}
                              name="securityBreachPlan"
                              id="securityBreachPlan"
                              label="Security Breach Plan"
                              placeholder="What is the security breach plan and what is the notification timeline?"
                            ></SelfSizingTextField>
                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                            <Tooltip title="What is the security breach plan and what is the notification timeline?">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>

                          <Grid item xs={12} sm={12} md={12}>

                            <FormControl>
                              <FormLabel id="demo-radio-buttons-group-label">Subcontractors required to protect data &nbsp;
                                <Tooltip title="Are all subcontractors outlined above required to protect UCC data in accordance with applicable privacy laws and privacy/security industry best practice?">
                                  <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                </Tooltip>
                              </FormLabel>
                              <RadioGroup
                                row
                                aria-labelledby="demo-radio-buttons-group-label"

                                name="radio-buttons-group"
                                //{...register('subcontractorDataProtection')}
                                onChange={(e) => handleSubcontractorRadioButtonChange(e, setSubcontractorDataProtection)}
                              >

                                {/* <FormControlLabel {...register('subcontractorDataProtection')} disabled={!currentUser.isSuperAdmin && !subcontractorDataProtection} key='1' value={'1'} checked={subcontractorDataProtection} control={<Radio />} label="Yes" />
                                    <FormControlLabel {...register('subcontractorDataProtection')} disabled={!currentUser.isSuperAdmin && subcontractorDataProtection} key='0' value={'0'} checked={subcontractorDataProtection === false} control={<Radio />} label="No" /> */}
                                <FormControlLabel {...register('subcontractorDataProtection')} key='1' value={'1'} checked={subcontractorDataProtection === '1'} control={<Radio />} label="Yes" />
                                <FormControlLabel {...register('subcontractorDataProtection')} key='0' value={'0'} checked={subcontractorDataProtection === '0'} control={<Radio />} label="No" />
                                <FormControlLabel {...register('subcontractorDataProtection')} key='2' value={'2'} checked={subcontractorDataProtection === '2'} control={<Radio />} label="N/A" />

                              </RadioGroup>

                            </FormControl>
                            <Typography variant="inherit" color="error.main">
                              {errors.subcontractorDataProtection?.message}
                            </Typography>

                          </Grid>
                          {/* <Tooltip arrow sx={{ padding: 0 }} placement="bottom-start" title="Are all subcontractors outlined above required to protect personally identifiable data in accordance with applicable privacy laws and privacy/security industry best practice?">
                              <FormControlLabel control={<Switch
                                checked={subcontractorDataProtection ?? false}
                                onChange={handleSubContractorChange}
                              />}
                                label="Subcontractors required to protect data"
                                {...register('subcontractorDataProtection')}
                              />
                            </Tooltip> */}

                          <Grid item xs={4} sm={4}>
                            <FormControl sx={{ m: 0, minWidth: 220 }}>
                              <InputLabel>Privacy Audit Frequency</InputLabel>
                              <Controller
                                name="auditFrequencyId"
                                control={control}
                                //defaultValue=""
                                // {...register("vendor")}
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    // disabled={!currentUser.isSuperAdmin}
                                    defaultValue={0}
                                    value={value}
                                    label="Privacy Audit Frequency"
                                    onChange={handleAuditFrequencyChange}
                                  >
                                    {auditFrequencyList.map((item, index) => <MenuItem key={index} value={item.id}>{item.name}</MenuItem>)}

                                  </Select>
                                )}
                              />
                            </FormControl>
                            <Typography variant="inherit" color="error.main">
                              {errors.auditFrequencyId?.message}
                            </Typography>

                          </Grid>
                          <Grid item xs={8} sm={8} md={8}>
                            {otherAuditShow && (
                              <TextField
                                fullWidth
                                // disabled={!currentUser.isSuperAdmin}
                                InputLabelProps={{ shrink: true }}
                                id="auditFrequencyOther"
                                name="auditFrequencyOther"
                                label="Other"
                                placeholder="Other"
                                {...register('auditFrequencyOther')}
                              />

                            )}
                            {otherAuditShow && (

                              <Typography variant="inherit" color="error.main">
                                {errors.auditFrequencyOther?.message}
                              </Typography>
                            )}
                          </Grid>
                          <Grid item xs={12} sm={12}  >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                // disabled={!currentUser.isSuperAdmin}
                                id="lastAuditDate"
                                name="lastAuditDate"
                                label="Date of Last Audit"
                                {...register('lastAuditDate')}
                                value={lastAuditDate}
                                onChange={(newValue) => {
                                  setLastAuditDate(newValue);
                                  setValue("lastAuditDate", newValue);
                                }}
                                renderInput={(params) => <TextField  {...params} />}
                              />
                            </LocalizationProvider>
                            <Typography variant="inherit" color="error.main">
                              {errors.lastAuditDate?.message}
                            </Typography>
                          </Grid>


                          {/* <Grid item xs={12} sm={12} md={12}>
                            <Tooltip arrow sx={{ padding: 0 }} placement="bottom-start" title="Confirm Compliance With ​Canada’s Data Privacy Act ​And ​PIPEDA​ Request For Mandatory Reporting Of A Data Breach ​“To Inform Individuals If Their Personal Information Has Been Lost, Stolen Or Inappropriately Accessed, And They Are Placed At Risk Of Harm.” Is This Articulated In Terms Of Service?">
                              <FormControlLabel control={<Switch
                                // disabled={!currentUser.isSuperAdmin}
                                checked={dataBreachCompliant ?? false}
                                onChange={handleDataBreachCompliantChange}
                                name="dataBreachCompliant"

                              />}
                                label="Data Breach Compliance"
                                {...register('dataBreachCompliant')}
                              />
                            </Tooltip>
                          </Grid> */}

                          <Grid item xs={11} >
                            <SelfSizingTextField
                              // disabled={!currentUser.isSuperAdmin}
                              initialValue={getValues('dataBackup')}
                              errors={errors.dataBackup}
                              register={register}
                              maxSize={2500}
                              name="dataBackup"
                              id="dataBackup"
                              label="Data Backup and Storage"
                              placeholder="How is the data stored and how is it backed up?"
                            ></SelfSizingTextField>
                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                            <Tooltip title="How often is the data backed up and how is it stored?">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>


                          <Grid item xs={11} >
                            <SelfSizingTextField
                              // disabled={!currentUser.isSuperAdmin}
                              initialValue={getValues('lossProtection')}
                              errors={errors.lossProtection}
                              register={register}
                              maxSize={2500}
                              name="lossProtection"
                              id="lossProtection"
                              label="Data Loss Protection"
                              placeholder="How is the data and the data backups protected from loss, theft and/or unauthorized access? (SIEM, encrypted in transit/at rest; password complexity etc.)"
                            ></SelfSizingTextField>
                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                            <Tooltip title="How is the data and the data backups protected from loss, theft and/or unauthorized access? (SIEM, encrypted in transit/at rest; password complexity etc.)">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>


                          {/* </Grid> */}

                          <Grid item xs={11}>
                            <Tooltip arrow sx={{ padding: 0 }} placement="bottom-start" title="For example, sharing to social media networks">
                              <FormControlLabel control={<Switch
                                // disabled={!currentUser.isSuperAdmin}
                                checked={internetPIPublished ?? false}
                                onChange={handleinternetPiChange}
                                name="internetPipublished"

                              />}
                                label="Software allows for publishing of personal information to the internet"
                                {...register('internetPipublished')}
                              />
                            </Tooltip>
                            <Tooltip title="Is there a feature of the software that allows posting to the internet, like on their public website or social media?">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>


                        </Fragment>
                      }
                      <Grid item xs={11}>

                        <SelfSizingTextField
                          required={false}
                          initialValue={getValues('complianceNotes')}
                          maxSize={2000}
                          errors={errors.complianceNotes}
                          register={register}
                          name="complianceNotes"
                          id="complianceNotes"
                          label="Compliance Notes"
                          placeholder="Compliance Notes"

                        ></SelfSizingTextField>

                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                        <Tooltip title="Any other data compliance information that is needed to be kept by the school.">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>
                    </Grid>


                  </Box>

                </Collapse>
                <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                  onClick={() => setGenAIOpen(!genAIOpen)}
                >
                  <Grid container sx={{ justifyContent: "space-between" }}>
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      Generative AI
                    </Typography>
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      {otherOpen ? <RemoveIcon /> : <AddIcon />}

                    </Typography>

                  </Grid>
                </Box>
                <Collapse in={genAIOpen} width={'100%'}>
                  <Box sx={{ border: 1 }} px={1} py={2}>

                    <Grid container spacing={2}>
                      <Grid item xs={6} sm={6} md={6}>

                        <FormControl>

                          <FormLabel id="gdpr-label">Does this cloud tool rely on external LLMs? </FormLabel>

                          <RadioGroup
                            row
                            aria-labelledby="demo-radio-buttons-group-label"

                            name="hasExternalLLMs"
                            {...register('hasExternalLLMs')}
                            //onChange={handleGdprChange}
                            onChange={(e) => {

                              handleBooleanRadioButtonChange(e, setHasExternalLLMs);

                            }}
                          >

                            <FormControlLabel {...register('hasExternalLLMs')} key='1' value={'1'} checked={hasExternalLLMs} control={<Radio />} label="Yes" />
                            <FormControlLabel {...register('hasExternalLLMs')} key='0' value={'0'} checked={hasExternalLLMs === false} control={<Radio />} label="No" />

                          </RadioGroup>
                        </FormControl>

                      </Grid>




                      <Grid item xs={6} sm={6} md={6}>

                        <FormControl>

                          <FormLabel id="gdpr-label">Does this tool use automated decision making?</FormLabel>

                          <RadioGroup
                            sx={{ backgroundColor: "#ecf7eb" }}
                            row
                            aria-labelledby="demo-radio-buttons-group-label"

                            name="automatedDecisionMaking"
                            {...register('automatedDecisionMaking')}
                            //onChange={handleGdprChange}
                            onChange={(e) => {

                              handleBooleanRadioButtonChange(e, setAutomatedDecisionMaking);

                            }}
                          >

                            <FormControlLabel {...register('automatedDecisionMaking')} key='1' value={'1'} checked={automatedDecisionMaking} control={<Radio />} label="Yes" />
                            <FormControlLabel {...register('automatedDecisionMaking')} key='0' value={'0'} checked={automatedDecisionMaking === false} control={<Radio />} label="No" />

                          </RadioGroup>
                        </FormControl>

                      </Grid>
                      {hasExternalLLMs &&
                        <Fragment>
                          <Grid item xs={11}>

                            <SelfSizingTextField
                              required={false}
                              initialValue={getValues('llmProviders')}
                              maxSize={1000}
                              errors={errors.LLMProviders}
                              register={register}
                              name="llmProviders"
                              id="llmProviders"
                              label="Which Providers are they hosted with?"
                              placeholder="Which Providers are they hosted with?"

                            ></SelfSizingTextField>

                          </Grid>
                          <Grid item xs={6} sm={6} md={6}>

                            <FormControl>

                              <FormLabel id="gdpr-label">Do your LLM providers train their general models on the queries submitted? </FormLabel>

                              <RadioGroup
                                row
                                aria-labelledby="demo-radio-buttons-group-label"

                                name="llmTraining"
                                {...register('llmTraining')}
                                //onChange={handleGdprChange}
                                onChange={(e) => {

                                  handleBooleanRadioButtonChange(e, setllmTraining);

                                }}
                              >

                                <FormControlLabel {...register('llmTraining')} key='1' value={'1'} checked={llmTraining} control={<Radio />} label="Yes" />
                                <FormControlLabel {...register('llmTraining')} key='0' value={'0'} checked={llmTraining === false} control={<Radio />} label="No" />

                              </RadioGroup>
                            </FormControl>

                          </Grid>
                          <Grid item xs={6} sm={6} md={6}>

                            <FormControl>

                              <FormLabel id="gdpr-label">Are the models trained with this data shared with other clients? </FormLabel>

                              <RadioGroup
                                row
                                aria-labelledby="demo-radio-buttons-group-label"

                                name="llmDataShared"
                                {...register('llmDataShared')}
                                //onChange={handleGdprChange}
                                onChange={(e) => {

                                  handleBooleanRadioButtonChange(e, setllmDataShared);

                                }}
                              >

                                <FormControlLabel {...register('llmDataShared')} key='1' value={'1'} checked={llmDataShared} control={<Radio />} label="Yes" />
                                <FormControlLabel {...register('llmDataShared')} key='0' value={'0'} checked={llmDataShared === false} control={<Radio />} label="No" />

                              </RadioGroup>
                            </FormControl>

                          </Grid>
                          <Grid item xs={11}>

                            <SelfSizingTextField
                              required={false}
                              initialValue={getValues('llmUnder18Treatment')}
                              maxSize={1000}
                              errors={errors.llmUnder18Treatment}
                              register={register}
                              name="llmUnder18Treatment"
                              id="llmUnder18Treatment"
                              label="Do you treat the data differently if the user is under 18?"
                              placeholder="Do you treat the data differently if the user is under 18?"

                            ></SelfSizingTextField>

                          </Grid>
                          <Grid item xs={11}>

                            <SelfSizingTextField
                              required={false}
                              initialValue={getValues('llmRestrict')}
                              maxSize={1000}
                              errors={errors.llmRestrict}
                              register={register}
                              name="llmRestrict"
                              id="llmRestrict"
                              label="What approach is taken to restrict access to training and inference data within your organization?"
                              placeholder="What approach is taken to restrict access to training and inference data within your organization?"

                            ></SelfSizingTextField>

                          </Grid>
                        </Fragment>
                      }
                    </Grid>


                  </Box>

                </Collapse>
                {/* Records of Processing - display conditionally */}

                {/* { currentUser.isSuperAdmin || currentUser.userEmail=='robert.macwilliam@gmail.com' && */}

                {hasROPModule && (

                  <Fragment>


                    <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                      onClick={() => setRecordsOfProcessingOpen(!recordsOfProcessingOpen)}
                    >
                      <Grid container sx={{ justifyContent: "space-between" }}>
                        <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                          Records of Processing
                        </Typography>
                        <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                          {recordsOfProcessingOpen ? <RemoveIcon /> : <AddIcon />}

                        </Typography>

                      </Grid>
                    </Box>
                    <Collapse in={recordsOfProcessingOpen} width={'100%'}>
                      <Box sx={{ border: 1 }} px={1} py={2}>
                        <Grid container spacing={2} style={{ paddingBottom: "20px" }}>
                          <Grid item xs={5} sm={5}>
                            <MultiSelectWithChips
                              label="Processing Purpose"
                              name="processingPurposeSelected"
                              control={control}
                              value={processingPurposeSelected}
                              infoSelected={processingPurposeSelected}
                              //infoNASelected={processingPurposeNASelected}
                              setinfoSelected={setProcessingPurposeSelected}
                              onChange={HandleChange}
                              handleChipDelete={handleChipDelete}
                              errors={errors.processingPurposeSelected}

                              items={processingPurposes}
                            >
                            </MultiSelectWithChips>

                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                            <Tooltip title="Description:
                                        This field describes why the school uses this application and what educational or operational function it supports. Schools should select the primary purpose(s) that most accurately reflect how the tool is used in practice, adding brief clarification only where necessary.
                                        Why it matters:
                                        GDPR requires schools to demonstrate that personal data is collected for clear, specific, and legitimate purposes. Clear purposes support transparency, data minimization, and accountability.">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>


                        </Grid>

                        <Grid item xs={6} sm={6} md={6} paddingRight={0}>
                          <SelfSizingTextField
                            required
                            initialValue={getValues('processingPurposeDescription')}
                            maxSize={1000}
                            errors={errors.processingPurposeDescriptionr}
                            register={register}
                            name="processingPurposeDescriptionr"
                            id="processingPurposeDescriptionr"
                            label="Processing Purpose Description"
                            dupefield="processingPurposeDescription"
                            setfunction={setValue}
                            placeholder="Description of the processing purpose."
                          ></SelfSizingTextField>
                        </Grid>
                        <Grid container spacing={2} style={{ paddingBottom: "20px", paddingTop: "10px" }}>
                          <Grid item xs={5} sm={5} md={5} style={{ paddingRight: 0 }}>
                            <MultiSelectWithChips
                              label="Department of Responsibility"
                              name="areaOfUseSelected"
                              control={control}
                              value={areaOfUseSelected}
                              infoSelected={areaOfUseSelected}
                              //infoNASelected={studentInfoNASelected}
                              setinfoSelected={setareaOfUseSelected}
                              onChange={HandleChange}
                              handleChipDelete={handleChipDeleteForApplicableDepts}
                              errors={errors.areaOfUseItems}

                              items={areaOfUseItems}
                            >
                            </MultiSelectWithChips>


                            <Typography variant="inherit" color="error.main">
                              {errors.areaOfUseSelected?.message}
                            </Typography>
                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                            <Tooltip title="What department(s) are using this software?">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>
                        </Grid>
                        {/* {otherProcessingPurposeShow &&
                          <Fragment>
                            <Grid item xs={4} sm={4}>
                              <FormControl sx={{ m: 0, minWidth: 230 }}>
                                <TextField
                                  // disabled={!currentUser.isSuperAdmin}
                                  id="otherProcessingPurpose"
                                  name="otherProcessingPurpose"
                                  label="Other Processing Purpose"
                                  fullWidth
                                  margin="dense"
                                  {...register('otherProcessingPurpose')}
                                  error={errors.otherProcessingPurpose ? true : false}
                                />
                              </FormControl>
                              <Typography variant="inherit" color="error.main">
                                {errors.otherProcessingPurpose?.message}
                              </Typography>


                            </Grid>
                            <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                              <Tooltip title="Other Processing Purpose ">
                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                              </Tooltip>
                            </Grid>
                          </Fragment>
                        } */}

                        <Grid item xs={12} sm={12} md={12} paddingTop={1}>
                          <Typography variant="inherit" >
                            Data Subjects and Categories of data &nbsp;&nbsp;
                            <Tooltip title="Description
                                          These fields identify personal information that is processed by the application. Schools should select all applicable groups whose data may be shared with or processed by the vendor.  This field captures the types of personal information processed by the application (for example: first name, lastname, email....). Schools should select all data categories that realistically apply based on actual use of the tool.  These fields are identical and mirror the fields in the data collection section.  If you edit them in that section, they will be updated here, and vice-versa.


                                        Why it matters
                                            GDPR requires schools to document which groups of individuals are affected by data processing activities. This ensures appropriate safeguards are applied, particularly where children’s data is involved.  Documenting data categories supports the principles of data minimization and proportionality. It also helps schools understand privacy risk and respond accurately to access or disclosure requests.">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Typography>

                        </Grid>
                        <Grid container spacing={-1} border={1} style={{ paddingTop: "20px", paddingLeft: "10px", paddingBottom: "10px" }} >

                          <Grid container spacing={2}>
                            {/* <Grid item xs={12} /> */}
                            <Grid item xs={5}>
                              <MultiSelectWithChips
                                label="Student Information"
                                name="studentInfoSelected"
                                control={control}
                                value={studentInfoSelected}
                                infoSelected={studentInfoSelected}
                                infoNASelected={studentInfoNASelected}
                                setinfoSelected={setstudentInfoSelected}
                                onChange={HandleChange}
                                handleChipDelete={handleChipDelete}
                                errors={errors.studentInfoSelected}
                                items={studentItems}
                              >
                              </MultiSelectWithChips>
                            </Grid>
                            <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                              <Tooltip title="Private student data fields that are sent to the 3rd party application. ">
                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                              </Tooltip>
                            </Grid>
                            <Grid item xs={5} >
                              <MultiSelectWithChips
                                label="Employee Information "
                                name="staffInfoSelected"
                                control={control}
                                value={staffInfoSelected}
                                infoSelected={staffInfoSelected}
                                infoNASelected={staffInfoNASelected}
                                setinfoSelected={setstaffInfoSelected}
                                onChange={HandleChange}
                                handleChipDelete={handleChipDelete}
                                errors={errors.staffInfoSelected}
                                items={staffItems}
                              >
                              </MultiSelectWithChips>

                            </Grid>
                            <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                              <Tooltip title="Private employee data fields that are sent to the 3rd party application. ">
                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                              </Tooltip>
                            </Grid>
                            <Grid item xs={5}>
                              <MultiSelectWithChips
                                label="Parent/Guardian Information"
                                name="parentInfoSelected"
                                control={control}
                                value={parentInfoSelected}
                                infoSelected={parentInfoSelected}
                                infoNASelected={parentInfoNASelected}
                                setinfoSelected={setparentInfoSelected}
                                onChange={HandleChange}
                                handleChipDelete={handleChipDelete}
                                errors={errors.parentInfoSelected}
                                items={parentItems}
                              >
                              </MultiSelectWithChips>

                              <Typography variant="inherit" color="error.main">
                                {errors.parentInfoSelected?.message}
                              </Typography>

                            </Grid>
                            <Grid item xs={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                              <Tooltip title="Private Parent/Guardian data fields that are sent to the 3rd party application.  ">
                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                              </Tooltip>
                            </Grid>
                            <Grid item xs={5}>
                              <MultiSelectWithChips
                                label="Alumni Information"
                                name="alumniInfoSelected"
                                control={control}
                                value={alumniInfoSelected}
                                infoSelected={alumniInfoSelected}
                                infoNASelected={alumniInfoNASelected}
                                setinfoSelected={setalumniInfoSelected}
                                onChange={HandleChange}
                                handleChipDelete={handleChipDelete}
                                errors={errors.alumniInfoSelected}
                                items={alumniItems}
                              >
                              </MultiSelectWithChips>

                            </Grid>
                            <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                              <Tooltip title="Private alumni data fields that are sent to the 3rd party application. ">
                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                              </Tooltip>
                            </Grid>
                            <Grid item xs={5}>
                              <MultiSelectWithChips
                                label="Volunteer Information"
                                name="volunteerInfoSelected"
                                control={control}
                                value={volunteerInfoSelected}
                                infoSelected={volunteerInfoSelected}
                                infoNASelected={volunteerInfoNASelected}
                                setinfoSelected={setVolunteerInfoSelected}
                                onChange={HandleChange}
                                handleChipDelete={handleChipDelete}
                                errors={errors.volunteerInfoSelected}
                                items={volunteerItems}
                              >
                              </MultiSelectWithChips>

                            </Grid>
                            <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                              <Tooltip title="Private volunteer data fields that are sent to the 3rd party application.  ">
                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                              </Tooltip>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid container spacing={-1} border={0} style={{ paddingTop: "10px", paddingLeft: "10px", paddingBottom: "10px" }} >
                          <Grid item xs={5} sm={5} md={5}>
                            <FormControl sx={{ m: 0, minWidth: 310 }}>
                              <InputLabel>Legal Basis for Processing</InputLabel>
                              <Controller
                                name="legalBasisForProcessingId"
                                control={control}
                                //defaultValue=""
                                // {...register("vendor")}
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    // disabled={!currentUser.isSuperAdmin}
                                    defaultValue={0}
                                    value={value}
                                    label="Legal Basis for Processing"
                                    onChange={legalBasisForProcessingChange}
                                  >
                                    {legalBasisForProcessingInfoItems.map((item, index) => <MenuItem key={index} value={item.id}>{item.name}</MenuItem>)}

                                  </Select>
                                )}
                              />
                            </FormControl>
                            <Typography variant="inherit" color="error.main">
                              {errors.auditFrequencyId?.message}
                            </Typography>

                          </Grid>
                          {/* <Grid item xs={5}></Grid> */}
                          {/* <Grid item xs={5} sm={5} md={5}>
                          <MultiSelectWithChips
                            label="Legal Basis for Processing"
                            name="legalBasisForProcessingInfoSelected"
                            control={control}
                            value={legalBasisForProcessingInfoSelected}
                            infoSelected={legalBasisForProcessingInfoSelected}
                            //infoNASelected={volunteerInfoNASelected}
                            setinfoSelected={setLegalBasisForProcessingInfoSelected}
                            onChange={HandleChange}
                            handleChipDelete={handleChipDelete}
                            errors={errors.legalBasisForProcessingInfoSelected}
                            items={legalBasisForProcessingInfoItems}
                          >
                          </MultiSelectWithChips>

                        </Grid> */}
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                            <Tooltip title="Description
                            This field records the lawful justification for processing personal data under applicable privacy legislation. Schools should select the legal basis that best reflects the real reason the data is processed, not the most convenient option.

                            Why it matters
                            GDPR requires every processing activity to have a valid legal basis. Selecting the correct basis demonstrates lawful processing and reduces reliance on consent where it is not appropriate in a school context. ">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>
                          <Grid item xs={6} sm={6} md={6} ></Grid>
                          <Grid item xs={6} sm={6} md={6} style={{ paddingTop: "10px", paddingLeft: "10px", paddingBottom: "10px" }}>

                            <FormControl>

                              <FormLabel id="gdpr-label">Does this vendor process special category data? </FormLabel>

                              <RadioGroup
                                row
                                aria-labelledby="demo-radio-buttons-group-label"

                                name="vendorSpecialCategoryData"
                                {...register('vendorSpecialCategoryData')}
                                //onChange={handleGdprChange}
                                onChange={(e) => {

                                  handleBooleanRadioButtonChange(e, setVendorSpecialCategoryData);

                                }}
                              >

                                <FormControlLabel {...register('vendorSpecialCategoryData')} key='1' value={'1'} checked={vendorSpecialCategoryData} control={<Radio />} label="Yes" />
                                <FormControlLabel {...register('vendorSpecialCategoryData')} key='0' value={'0'} checked={vendorSpecialCategoryData === false} control={<Radio />} label="No" />

                              </RadioGroup>
                            </FormControl>

                          </Grid>
                          {vendorSpecialCategoryData &&
                            <Fragment>
                              <Grid item xs={5} sm={5} md={5}>
                                <MultiSelectWithChips
                                  label="Special Category Data"
                                  name="specialCategoryDataSelected"
                                  control={control}
                                  value={specialCategoryDataSelected}
                                  infoSelected={specialCategoryDataSelected}
                                  //infoNASelected={volunteerInfoNASelected}
                                  setinfoSelected={setSpecialCategoryDataSelected}
                                  onChange={HandleChange}
                                  handleChipDelete={handleChipDelete}
                                  errors={errors.specialCategoryDataSelected}
                                  items={specialCategoryDataItems}
                                >
                                </MultiSelectWithChips>

                              </Grid>
                              <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                                <Tooltip title="Description
This field indicates whether the application processes sensitive personal information such as health, learning support, or safeguarding data. Schools should select all applicable categories if such data may be stored or accessed within the system.

Why it matters
Special category data requires higher protection under GDPR. Identifying its presence ensures enhanced safeguards are considered and documented. ">
                                  <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                </Tooltip>
                              </Grid>
                            </Fragment>
                          }
                          <Grid item xs={8} sm={8} md={8} ></Grid>
                          <Grid item xs={5} sm={5}>
                            <MultiSelectWithChips
                              label="Where does the data reside?"
                              name="dataLocationSelected"
                              control={control}
                              value={dataLocationSelected}
                              infoSelected={dataLocationSelected}
                              //infoNASelected={studentInfoNASelected}
                              setinfoSelected={setdataLocationSelected}
                              onChange={HandleChange}
                              handleChipDelete={handleChipDelete}
                              errors={errors.dataLocationSelected}

                              items={dataLocationItems}
                            >
                            </MultiSelectWithChips>
                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                            <Tooltip title="Description:
This field records the primary geographic location where personal data is stored or hosted by the vendor. This information is typically drawn from the vendor’s documentation or Privacy Impact Assessment.

Why it matters:
Knowing where data is stored supports compliance with international privacy laws and helps schools assess legal, regulatory, and risk implications related to cross-border data storage.">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>
                          <Grid item xs={4} sm={4} md={4}>
                            <FormControl>
                              <FormLabel id="demo-radio-buttons-group-label">International Transfer Flag</FormLabel>
                              <RadioGroup
                                row
                                aria-labelledby="demo-radio-buttons-group-label"

                                name="radio-buttons-group"
                              // {...register('cloudHosted')}
                              // onChange={(e) => {

                              //   handleBooleanRadioButtonChange(e, setCloudHosted);

                              // }}
                              >
                                {/* <FormControlLabel {...register('cloudHosted')} disabled={!currentUser.isSuperAdmin && !cloudHosted} key='1' value={'1'} checked={cloudHosted} control={<Radio />} label="Yes" />
                              <FormControlLabel {...register('cloudHosted')} disabled={!currentUser.isSuperAdmin && cloudHosted} key='0' value={'0'} checked={cloudHosted === false} control={<Radio />} label="No" /> */}
                                <FormControlLabel {...register('internationalTransferFlag')} key='1' value={'1'} checked={internationalTransferFlag} control={<Radio />} label="Yes" />
                                <FormControlLabel {...register('internationalTransferFlag')} key='0' value={'0'} checked={internationalTransferFlag === false} control={<Radio />} label="No" />

                              </RadioGroup>
                            </FormControl>
                            <Tooltip title="Description
This field records the lawful justification for processing personal data under applicable privacy legislation. Schools should select the legal basis that best reflects the real reason the data is processed, not the most convenient option.

Why it matters
GDPR requires every processing activity to have a valid legal basis. Selecting the correct basis demonstrates lawful processing and reduces reliance on consent where it is not appropriate in a school context.">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>

                          </Grid>
                          <Grid item xs={8} sm={8} md={8} >

                          </Grid>
                          <Grid item xs={5} sm={5} md={5}>
                            <MultiSelectWithChips
                              label="Transfer Safeguards"
                              name="transferSafeguardsSelected"
                              control={control}
                              value={transferSafeguardsSelected}
                              infoSelected={transferSafeguardsSelected}
                              //infoNASelected={studentInfoNASelected}
                              setinfoSelected={setTransferSafeguardsSelected}
                              onChange={HandleChange}
                              handleChipDelete={handleChipDelete}
                              errors={errors.transferSafeguardsSelected}

                              items={transferSafeguardsItems}
                            >
                            </MultiSelectWithChips>
                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                            <Tooltip title="Description
This field records the lawful justification for processing personal data under applicable privacy legislation. Schools should select the legal basis that best reflects the real reason the data is processed, not the most convenient option.

Why it matters
GDPR requires every processing activity to have a valid legal basis. Selecting the correct basis demonstrates lawful processing and reduces reliance on consent where it is not appropriate in a school context.">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>

                          <Grid item xs={5} sm={5} md={5} style={{ paddingTop: "10px" }}>

                            <SelfSizingTextField
                              required={false}
                              initialValue={getValues('transferSafeguardsNotes')}
                              maxSize={2000}
                              errors={errors.transferSafeguardsNotes}
                              register={register}
                              name="transferSafeguardsNotes"
                              id="transferSafeguardsNotes"
                              label="Transfer Safeguards Notes"
                              placeholder="Transfer Safeguards Notes"

                            ></SelfSizingTextField>

                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                            <Tooltip title="Any other transfer safeguard information that is needed to be kept by the school.">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>
                          <Grid item xs={11} style={{ paddingTop: "20px", paddingRight: 0 }} >
                            <SelfSizingTextField
                              // disabled={!currentUser.isSuperAdmin}
                              initialValue={getValues('dataRetentionPolicy')}
                              errors={errors.dataRetentionPolicy}
                              register={register}
                              maxSize={2500}
                              name="dataRetentionPolicyr"
                              id="dataRetentionPolicyr"
                              dupefield="dataRetentionPolicy"
                              setfunction={setValue}
                              label="Data Retention Policy"
                              placeholder="Describe the data retention policy for active and inactive accounts"
                            ></SelfSizingTextField>
                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0 }}>
                            <Tooltip title="What is the data retention policy for the country - for active accounts and for inactive accounts.">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>
                          <Grid item xs={11} style={{ paddingTop: "20px", paddingRight: 0 }} >
                            <SelfSizingTextField
                              // disabled={!currentUser.isSuperAdmin}
                              initialValue={getValues('dataAfterDiscontinuing')}
                              errors={errors.dataAfterDiscontinuing}
                              register={register}
                              maxSize={1500}
                              name="dataAfterDiscontinuing"
                              id="dataAfterDiscontinuing"
                              label="Data Discontinuance"
                              dupefield="dataAfterDiscontinuingr"
                              setfunction={setValue}
                              placeholder="What happens to the data if relationship with the software vendor is discontinued."
                            ></SelfSizingTextField>
                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                            <Tooltip title="How is private data removed from the application if the school is no longer a client?">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>

                          <Grid item xs={5} sm={5} md={5}>
                            <MultiSelectWithChips
                              label="Security Measures (High-level)"
                              name="securityMeasuresSelected"
                              control={control}
                              value={securityMeasuresSelected}
                              infoSelected={securityMeasuresSelected}
                              //infoNASelected={studentInfoNASelected}
                              setinfoSelected={setSecurityMeasuresSelected}
                              onChange={HandleChange}
                              handleChipDelete={handleChipDelete}
                              errors={errors.securityMeasuresSelected}

                              items={securityMeasuresItems}
                            >
                            </MultiSelectWithChips>
                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                            <Tooltip title="Description
This field records the lawful justification for processing personal data under applicable privacy legislation. Schools should select the legal basis that best reflects the real reason the data is processed, not the most convenient option.

Why it matters
GDPR requires every processing activity to have a valid legal basis. Selecting the correct basis demonstrates lawful processing and reduces reliance on consent where it is not appropriate in a school context.">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>

                          <Grid item xs={11} style={{ paddingTop: "20px", paddingRight: 0 }} >
                            <SelfSizingTextField
                              // disabled={!currentUser.isSuperAdmin}
                              initialValue={getValues('recordsOfProcessingNotes')}
                              errors={errors.recordsOfProcessingNotes}
                              register={register}
                              maxSize={1500}
                              name="recordsOfProcessingNotes"
                              id="recordsOfProcessingNotes"
                              label="Records of Processing Notes"
                              placeholder="Records of Processing Notes"
                            ></SelfSizingTextField>
                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                            <Tooltip title="Records of Processing Notes">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>

                          <Grid item xs={6} sm={6} md={6} style={{ paddingTop: "10px", paddingRight: 0 }}>

                            <FormControl>

                              <FormLabel id="gdpr-label">Does this tool use automated decision making?</FormLabel>

                              <RadioGroup
                                row
                                aria-labelledby="demo-radio-buttons-group-label"

                                name="automatedDecisionMaking"
                                {...register('automatedDecisionMaking')}
                                //onChange={handleGdprChange}
                                onChange={(e) => {

                                  handleBooleanRadioButtonChange(e, setAutomatedDecisionMaking);

                                }}
                              >

                                <FormControlLabel {...register('automatedDecisionMaking')} key='1' value={'1'} checked={automatedDecisionMaking} control={<Radio />} label="Yes" />
                                <FormControlLabel {...register('automatedDecisionMaking')} key='0' value={'0'} checked={automatedDecisionMaking === false} control={<Radio />} label="No" />

                              </RadioGroup>
                            </FormControl>

                          </Grid>

                        </Grid>
                      </Box>
                    </Collapse>

                  </Fragment>
                )}
                {/* } */}
                <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                  onClick={() => setApprovalOpen(!approvalOpen)}
                >
                  <Grid container sx={{ justifyContent: "space-between" }}>
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      Approval
                    </Typography>
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      {approvalOpen ? <RemoveIcon /> : <AddIcon />}

                    </Typography>

                  </Grid>
                </Box>
                <Collapse in={approvalOpen} width={'100%'}>
                  <Box sx={{ border: 1 }} px={1} py={2}>
                    <Grid container>
                      <Grid item xs={4} sm={4} md={4}>

                        <FormControlLabel control={<Switch
                          checked={approved ?? false}
                          onChange={(event) => handleApprovedChange(event)}
                          name="approved"

                        />}
                          label="Approved"
                          {...register('approved')}
                        />
                        <Tooltip title="Has the school approved the software for use?">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>

                      {approved &&
                        <Fragment>
                          <Grid item xs={3} >
                            <FormControl sx={{ m: 0, width: 190 }}>
                              <InputLabel> Approved By </InputLabel>
                              <Controller
                                name="approverId"
                                control={control}
                                defaultValue=""
                                render={({ field: { onChange, value } }) => (
                                  <Select
                                    defaultValue={''}
                                    value={value}
                                    label="Approved By"
                                    onChange={(e) => setValue('approverId', e.target.value, { shouldValidate: true })}
                                  >
                                    {approverList.map((item, index) => <MenuItem key={index} value={item.lookupItemId}>{item.name}</MenuItem>)}

                                  </Select>
                                )}
                              />
                            </FormControl>
                            <Typography variant="inherit" color="error.main">
                              {errors.approverId?.message}
                            </Typography>
                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "10px", paddingRight: 0, paddingLeft: "5px" }}>
                            <Tooltip title="Who has approved the software?">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>
                        </Fragment>
                      }
                      {approved &&
                        <Fragment>
                          <Grid item xs={3} >
                            <FormControl sx={{ m: 0, width: 190 }}>
                              {/* <InputLabel> Approved By </InputLabel> */}
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  id="approvalDate"
                                  name="approvalDate"
                                  label="Approved On"
                                  {...register('approvalDate')}
                                  value={approvalDate}
                                  onChange={(newValue) => {
                                    setApprovalDate(newValue);
                                    setValue("approvalDate", newValue);
                                  }}
                                  renderInput={(params) => <TextField  {...params} />}
                                />

                              </LocalizationProvider>
                              <Typography variant="inherit" color="error.main">
                                {errors.approvedDate?.message}
                              </Typography>
                            </FormControl>
                          </Grid>
                          <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "10px", paddingRight: 0, paddingLeft: "5px" }}>
                            <Tooltip title="When was this software approved (will show on the list of 'Institutions Approved'.">
                              <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                            </Tooltip>
                          </Grid>
                        </Fragment>
                      }
                    </Grid>


                    <Grid container spacing={2}>
                      <Grid item xs={4} sm={4} md={4}>

                        <FormControlLabel control={<Switch
                          checked={notApproved ?? false}
                          onChange={(event) => handleNotApprovedChange(event)}
                          name="notApproved"

                        />}
                          label="Not Approved"
                          {...register('notApproved')}
                        />

                      </Grid>
                      <Grid item xs={6} sm={7} md={6}>

                        {notApproved && (
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            multiline

                            id="notApprovedReason"
                            name="notApprovedReason"
                            label="Rationale for Not Approving"
                            placeholder="If the sofware was not approved, describe why"
                            //minRows={1}
                            fullWidth
                            {...register('notApprovedReason')}

                          />
                        )}
                        {notApproved && (
                          <Typography variant="inherit" color="error.main">
                            {errors.notApprovedReason?.message}
                          </Typography>
                        )}

                      </Grid>



                      <Grid item xs={4} sm={4} md={4}>
                        {/* <FormControl sx={{ m: 0, width: 250 }}> */}
                        {/* <InputLabel> Approved By </InputLabel> */}
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            id="lastUpdatedDate"
                            name="lastUpdatedDate"
                            label="Date Last Updated"
                            {...register('lastUpdatedDate')}
                            value={lastUpdatedDate}
                            disabled={true}
                            renderInput={(params) => <TextField  {...params} />}
                          />

                        </LocalizationProvider>

                        {/* </FormControl> */}

                      </Grid>
                      <Grid item xs={4} sm={4} md={4}>
                        <FormControl sx={{ m: 0, width: 250 }}>
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            disabled={true}
                            width={250}
                            id="completedBy"
                            name="completedBy"
                            label="Updated By"
                            placeholder="Updated By"
                            value={completedBy}
                            //minRows={1}
                            fullWidth


                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                        <Tooltip title="Needed for compliance - will need to show re-approval process.">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>
                      <Grid item xs={11} >

                        <SelfSizingTextField
                          required={false}
                          initialValue={getValues('approvalNotes')}
                          maxSize={2000}
                          errors={errors.approvalNotes}
                          register={register}
                          name="approvalNotes"
                          id="approvalNotes"
                          label="Approval Notes"
                          placeholder="Approval Notes"

                        ></SelfSizingTextField>

                      </Grid>
                      <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                        <Tooltip title="Any other approval information that is needed to be kept by the school.">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid>



                    </Grid>
                  </Box>
                </Collapse>

              </Box>

            </form>
          </DialogContent>
          <DialogActions>
            {(isSchoolRecord || currentUser.isSuperAdmin) && (
              <Fragment>
                {/* <Button color="primary" onClick={handleSubmit(onSubmitSaveOnly)}>Save</Button> */}
                {/* <Button color="primary" onClick={runValidations}>Validate</Button>   */}
                <Button color="primary" onClick={handleSubmit(onSubmit)}>Save</Button>
              </Fragment>
            )}

            <Button onClick={handleCancel}>Cancel</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={deleteOpen} onClose={handleDeleteCancel}>
          <DialogTitle>Inactivate PIA {deleteName}?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              You are marking this application as inactive. To make the application active again, filter by inactive.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={handleDelete}>Inactivate</Button>
            <Button onClick={handleDeleteCancel}>Cancel</Button>
          </DialogActions>
        </Dialog>
      </div>
    </div >

  );


}
